import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { getSplit, addParticipant, deleteParticipant } from '$lib/api/splits';
import Button from '$lib/components/ui/button/button.svelte';
import * as Card from '$lib/components/ui/card';
import Input from '$lib/components/ui/input/input.svelte';
import Label from '$lib/components/ui/label/label.svelte';
import ConfirmDialog from '$lib/components/ui/confirm-dialog/confirm-dialog.svelte';
import ExpenseEditModal from '$lib/components/expense/ExpenseEditModal.svelte';
import EditParticipantModal from '$lib/components/participant/EditParticipantModal.svelte';
import ParticipantExpensesModal from '$lib/components/participant/ParticipantExpensesModal.svelte';
import ParticipantSummaryCard from '$lib/components/participant/ParticipantSummaryCard.svelte';
import { addToast } from '$lib/stores/toastStore.svelte';
import { route, navigate } from '$lib/router';
import { loadNightsDefault, saveNightsDefault } from '$lib/stores/nightsDefaultStore';

import {
	User,
	Plus,
	Wallet,
	Receipt,
	TrendingUp,
	TrendingDown,
	Minus,
	Info,
	X,
	Users,
	HelpCircle,
	List
} from '$lib/icons';

import SplitPageHeader from '$lib/components/ui/split-page-header/SplitPageHeader.svelte';
import { getCachedSplitName, setCachedSplitName } from '$lib/stores/splitTitleCache';
import { tick } from 'svelte';

var root_2 = $.from_html(`<div class="flex flex-col items-center justify-center py-12 space-y-4"><svg class="animate-spin h-8 w-8 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg> <p class="text-muted-foreground">Loading participants...</p></div>`);
var root_5 = $.from_html(`<div class="w-full flex items-center gap-2 px-3 py-2 rounded-md bg-amber-50 border border-amber-200 text-sm text-amber-800"><span class="flex-1">This split is settled — participants are read-only.</span> <button class="underline font-medium whitespace-nowrap">View settlement</button></div>`);
var root_10 = $.from_html(`<p class="text-sm text-destructive"> </p>`);
var root_12 = $.from_html(`<p class="text-sm text-destructive"> </p>`);
var root_15 = $.from_html(`<p class="text-sm text-destructive"> </p>`);
var root_13 = $.from_html(`<div class="space-y-2 flex-1"><div class="flex items-center gap-1"><!> <button type="button" class="p-0.5 rounded-full hover:bg-muted text-muted-foreground" aria-label="Info about Members"><!></button></div> <!> <!></div>`);
var root_8 = $.from_html(`<form class="space-y-3"><p class="text-sm font-medium text-teal-700"> </p> <div class="space-y-2"><!> <!> <!></div> <div class="flex gap-3"><div class="space-y-2 flex-1"><div class="flex items-center gap-1"><!> <button type="button" class="p-0.5 rounded-full hover:bg-muted text-muted-foreground" aria-label="Info about Nights"><!></button></div> <!> <!></div> <!></div> <div class="flex gap-2"><!> <!></div></form>`);
var root_20 = $.from_html(`<!> Add Single Participant`, 1);
var root_21 = $.from_html(`<!> Add Family Participant`, 1);
var root_19 = $.from_html(`<div class="flex flex-col sm:flex-row gap-2 w-full"><!> <div class="flex gap-2 sm:contents"><!> <!></div></div>`);
var root_23 = $.from_html(`<div class="w-full rounded-lg border border-dashed border-teal-300 bg-teal-50 px-6 py-8 text-center space-y-2"><p class="font-semibold text-teal-800">Add your first participant to get started</p> <p class="text-sm text-teal-700">Use the buttons above to add a single person or a family group. You need at least one participant before adding expenses.</p></div>`);
var root_30 = $.from_svg(`<svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor"><path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"></path></svg>`);
var root_31 = $.from_svg(`<svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd"></path></svg>`);
var root_28 = $.from_html(`<!> <!> <!>`, 1);
var root_32 = $.from_html(`<span class="text-xs px-2 py-0.5 rounded-full bg-blue-100 text-blue-700"> </span>`);
var root_33 = $.from_html(`<span class="flex items-center gap-1 text-xs px-2 py-0.5 rounded-full bg-violet-100 text-violet-700"><!> </span>`);
var root_34 = $.from_html(`<!> <span class="font-medium"> </span>`, 1);
var root_36 = $.from_html(`<!> <span class="font-medium"> </span>`, 1);
var root_37 = $.from_html(`<!> <span class="font-medium">Settled</span>`, 1);
var root_26 = $.from_html(`<div class="flex flex-col gap-1"><div class="flex items-center justify-between gap-2"><span class="font-semibold text-lg truncate min-w-0 flex-1"> </span> <div class="flex-none flex items-center gap-1"><!> <!></div></div> <div class="flex flex-wrap items-center gap-1"><span class="text-xs px-2 py-0.5 rounded-full bg-teal-100 text-teal-700"> </span> <!> <span class="text-xs px-2 py-0.5 rounded-full bg-slate-100 text-slate-600"> </span> <!></div> <div class="flex items-center justify-between text-base"><span class="flex items-center gap-1 text-muted-foreground" title="Spent"><!> <span class="font-medium text-foreground"> </span></span> <span class="flex items-center gap-1 text-muted-foreground" title="Cost"><!> <span class="font-medium text-foreground"> </span></span> <span title="Balance"><!></span></div></div>`);
var root_4 = $.from_html(`<!> <!> <!> <!> <!>`, 1);
var root_41 = $.from_html(`<p class="text-sm text-muted-foreground leading-relaxed"> </p>`);
var root_39 = $.from_html(`<div class="fixed inset-0 z-[70] bg-black/50 flex items-end justify-center sm:items-center sm:p-4" role="dialog" aria-modal="true" aria-labelledby="field-info-title" tabindex="-1"><div role="presentation" class="bg-background w-full sm:max-w-[420px] rounded-t-xl sm:rounded-xl shadow-lg animate-in fade-in slide-in-from-bottom-4 sm:zoom-in-95"><div class="flex items-center justify-between p-4 border-b"><h2 id="field-info-title" class="text-base font-semibold"> </h2> <!></div> <div class="p-4 space-y-3"></div> <div class="p-4 border-t"><!></div></div></div>`);
var root_45 = $.from_html(`<div class="fixed inset-0 z-[70] bg-black/50 flex items-end justify-center sm:items-center sm:p-4" role="dialog" aria-modal="true" aria-labelledby="help-modal-title" tabindex="-1"><div role="presentation" class="bg-background w-full sm:max-w-[480px] rounded-t-xl sm:rounded-xl shadow-lg animate-in fade-in slide-in-from-bottom-4 sm:zoom-in-95"><div class="flex items-center justify-between p-4 border-b"><h2 id="help-modal-title" class="text-base font-semibold">How to add participants</h2> <!></div> <div class="p-4 space-y-4 text-sm text-muted-foreground"><div class="space-y-1"><p class="font-semibold text-foreground flex items-center gap-1.5"><!> Single Participant</p> <p>One person attending the trip on their own. Use this for individuals who travel solo or whose costs should not be shared with anyone else.</p> <p class="text-xs bg-muted rounded px-2 py-1.5">Example: Alice stays for 4 nights → add Alice as a single participant with 4 nights.</p></div> <div class="space-y-1"><p class="font-semibold text-foreground flex items-center gap-1.5"><!> Family Participant</p> <p>A group (couple, family) whose costs are pooled together. Set <strong>Members</strong> to the total head-count — adults count as 1, children can count as 0.5.</p> <p class="text-xs bg-muted rounded px-2 py-1.5">Example: The Smiths (2 adults + 2 kids) stay 7 nights → add them as a family with 7 nights and 3 members (2 × 1 + 2 × 0.5).</p></div> <div class="space-y-1"><p class="font-semibold text-foreground">Mixed scenario</p> <p>If one parent leaves early, add them separately as a single participant with fewer nights. The rest of the family keeps the full stay.</p> <p class="text-xs bg-muted rounded px-2 py-1.5">Example: Dad leaves after 3 nights → add Dad (single, 3 nights) + the rest of the family (family, 7 nights, 2.5 members).</p></div></div> <div class="p-4 border-t"><!></div></div></div>`);
var root = $.from_html(`<div class="flex flex-col items-center space-y-4 w-full max-w-[520px] mx-auto"><!> <!></div> <!> <!> <!> <!> <!> <!>`, 1);

export default function Participants($$anchor, $$props) {
	$.push($$props, true);

	// Participants Edition Page
	// Field info modal state (add form)
	let activeFieldInfo = $.state(null);

	// Help modal state
	let showHelp = $.state(false);

	const fieldInfo = {
		nights: {
			title: 'Nights',
			description: `The number of nights this participant stays during the trip.\n\nUsed in the "By Night" split mode: costs are divided proportionally based on each participant's nights × share weight.\n\nExample: a participant staying 3 nights out of a 7-night trip pays for 3/7 of the night-based expenses (adjusted by their share).`
		},

		members: {
			title: 'Members',
			description: `The number of people in this family group.\n\nAdults count as 1 each. Children can count for 0.5 to reflect their lower consumption.\n\nExample: a family of 2 adults and 2 children staying 7 nights → 3 members (2 × 1 + 2 × 0.5).\n\nIf one parent leaves early (e.g. stays only 3 nights), add them as a separate single participant with 3 nights and a share of 1. The rest of the family can then be entered with fewer members.`
		}
	};

	const splitId = $.derived(() => route.params.splitId || '');

	// State
	let split = $.state(null);

	let splitDisplayName = $.state($.proxy(getCachedSplitName(route.params.splitId || '')));
	const sortedParticipants = $.derived(() => $.get(split)?.participants.slice().sort((a, b) => a.name.localeCompare(b.name)) ?? []);
	const isSettled = $.derived(() => $.get(split)?.settlement != null);
	let isLoading = $.state(true);
	let showLoading = $.state(false);
	let loadingTimer = null;

	// Add Participant form state
	let addMode = $.state(null);

	let nameInputEl = $.state(null);
	let formName = $.state('');
	let formNights = $.state(1);
	let formMembers = $.state(1);
	let validationErrors = $.state($.proxy({}));
	let isSubmitting = $.state(false);

	// Edit Participant state
	let showEditParticipantModal = $.state(false);

	let editingParticipant = $.state(null);
	let highlightedParticipantId = $.state(null);

	// Delete Participant state
	let deletingParticipantId = $.state(null);

	let deletingParticipantName = $.state('');
	let isDeleteSubmitting = $.state(false);

	// Add Expense Modal state
	let showAddExpenseModal = $.state(false);

	let selectedPayerId = $.state(null);

	// Participant Expenses Modal state
	let showExpensesModal = $.state(false);

	let selectedParticipantForExpenses = $.state(null);

	// Load split data
	$.user_effect(() => {
		if ($.get(splitId)) {
			loadSplit($.get(splitId));
		}
	});

	async function loadSplit(id) {
		$.set(isLoading, true);
		$.set(showLoading, false);

		if (loadingTimer) clearTimeout(loadingTimer);

		loadingTimer = setTimeout(
			() => {
				$.set(showLoading, true);
			},
			500
		);

		try {
			$.set(split, await getSplit(id), true);
			$.set(splitDisplayName, $.get(split).name, true);
			setCachedSplitName(id, $.get(split).name);
		} catch(err) {
			const apiError = err;

			if (apiError.status === 404 || apiError.status === 400) {
				addToast({ type: 'info', message: 'Split not found — create a new one.' });
				navigate('/');
			} else {
				addToast({
					type: 'error',
					message: apiError.detail || 'Failed to load participants'
				});
			}
		} finally {
			$.set(isLoading, false);
			$.set(showLoading, false);

			if (loadingTimer) {
				clearTimeout(loadingTimer);
				loadingTimer = null;
			}
		}
	}

	// Per-participant stats calculation
	function getParticipantStats(participantId) {
		if (!$.get(split)) return { spent: 0, cost: 0, balance: 0, expenseCount: 0 };

		const spent = $.get(split).expenses.filter((e) => e.payerId === participantId).reduce((sum, e) => sum + e.amount, 0);

		const cost = $.get(split).expenses.reduce(
			(sum, e) => {
				const share = e.shares.find((s) => s.participantId === participantId);

				return sum + (share?.amount || 0);
			},
			0
		);

		const expenseCount = $.get(split).expenses.filter((e) => e.payerId === participantId).length;
		const balance = spent - cost;

		return { spent, cost, balance, expenseCount };
	}

	function formatName(name) {
		if (!name) return name;

		return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
	}

	function formatCurrency(amount) {
		return new Intl.NumberFormat('en-IE', { style: 'currency', currency: 'EUR' }).format(amount);
	}

	function balanceColorClass(balance) {
		if (balance > 0.005) return 'text-green-600';
		if (balance < -0.005) return 'text-red-600';

		return 'text-muted-foreground';
	}

	function balanceLabel(balance) {
		if (balance > 0.005) return `Owed ${formatCurrency(balance)}`;
		if (balance < -0.005) return `Owes ${formatCurrency(Math.abs(balance))}`;

		return 'Settled';
	}

	// Returns the names of co-members in the same shared account group, or null if not grouped.
	function getSharedAccountPartners(participant) {
		if (!participant.sharedAccountId || !$.get(split)) return null;

		const partners = $.get(split).participants.filter((p) => p.id !== participant.id && p.sharedAccountId === participant.sharedAccountId).map((p) => p.name).sort();

		return partners.length > 0 ? partners : null;
	}

	// Add Participant handlers
	async function handleShowSingleForm() {
		$.set(addMode, 'single');
		$.set(formName, '');
		$.set(formNights, loadNightsDefault(), true);
		$.set(validationErrors, {}, true);
		await tick();
		$.get(nameInputEl)?.focus();
	}

	async function handleShowFamilyForm() {
		$.set(addMode, 'family');
		$.set(formName, '');
		$.set(formNights, loadNightsDefault(), true);
		$.set(formMembers, 1);
		$.set(validationErrors, {}, true);
		await tick();
		$.get(nameInputEl)?.focus();
	}

	function handleCancelAddForm() {
		$.set(addMode, null);
		$.set(formName, '');
		$.set(formNights, 1);
		$.set(formMembers, 1);
		$.set(validationErrors, {}, true);
	}

	function validateNameOnInput() {
		if (!$.get(formName).trim()) {
			$.set(validationErrors, { ...$.get(validationErrors), name: undefined }, true);

			return;
		}

		let nameError;

		if ($.get(formName).trim().length > 50) {
			nameError = 'Name cannot exceed 50 characters';
		} else if ($.get(split)?.participants.some((p) => p.name.toLowerCase() === $.get(formName).trim().toLowerCase())) {
			nameError = 'A participant with this name already exists';
		}

		$.set(validationErrors, { ...$.get(validationErrors), name: nameError }, true);
	}

	function validateNightsOnInput() {
		let nightsError;

		if ($.get(formNights) < 1) {
			nightsError = 'Nights must be at least 1';
		} else if ($.get(formNights) > 365) {
			nightsError = 'Nights cannot exceed 365';
		}

		$.set(validationErrors, { ...$.get(validationErrors), nights: nightsError }, true);
	}

	function validateMembersOnInput() {
		let error;

		if ($.get(formMembers) < 0.5) {
			error = 'Must be at least 0.5';
		} else if ($.get(formMembers) > 50) {
			error = 'Cannot exceed 50';
		}

		$.set(validationErrors, { ...$.get(validationErrors), members: error }, true);
	}

	function validateAddForm() {
		const errors = {};

		if (!$.get(formName).trim()) {
			errors.name = 'Name is required';
		} else if ($.get(formName).trim().length > 50) {
			errors.name = 'Name cannot exceed 50 characters';
		} else if ($.get(split)?.participants.some((p) => p.name.toLowerCase() === $.get(formName).trim().toLowerCase())) {
			errors.name = 'A participant with this name already exists';
		}

		if ($.get(formNights) < 1) {
			errors.nights = 'Nights must be at least 1';
		} else if ($.get(formNights) > 365) {
			errors.nights = 'Nights cannot exceed 365';
		}

		if ($.get(addMode) === 'family') {
			if ($.get(formMembers) < 0.5) {
				errors.members = 'Must be at least 0.5';
			} else if ($.get(formMembers) > 50) {
				errors.members = 'Cannot exceed 50';
			}
		}

		$.set(validationErrors, errors, true);

		return Object.keys(errors).length === 0;
	}

	async function handleAddParticipant() {
		if (!validateAddForm()) return;

		$.set(isSubmitting, true);

		try {
			const addedName = $.get(formName).trim();
			const addedNights = $.get(formNights);
			const addedShare = $.get(addMode) === 'family' ? $.get(formMembers) : 1;

			await addParticipant($.get(splitId), { name: addedName, nights: addedNights, share: addedShare });
			saveNightsDefault(addedNights);
			$.set(addMode, null);
			$.set(formName, '');
			$.set(formNights, 1);
			$.set(formMembers, 1);
			$.set(validationErrors, {}, true);
			await loadSplit($.get(splitId));

			addToast({
				type: 'success',
				message: `${addedName} successfully added`,
				description: `${addedNights} nights · share ${addedShare}`,
				duration: 4000
			});
		} catch(err) {
			addToast({
				type: 'error',
				message: err.detail || 'Failed to add participant. Please try again.'
			});
		} finally {
			$.set(isSubmitting, false);
		}
	}

	// Edit Participant handlers
	function handleStartEdit(participant) {
		$.set(editingParticipant, participant, true);
		$.set(showEditParticipantModal, true);
	}

	function handleEditModalClose() {
		$.set(showEditParticipantModal, false);
		$.set(editingParticipant, null);
	}

	async function handleEditSuccess() {
		const updatedParticipantId = $.get(editingParticipant)?.id;

		$.set(showEditParticipantModal, false);
		$.set(editingParticipant, null);
		await loadSplit($.get(splitId));

		if (updatedParticipantId) {
			$.set(highlightedParticipantId, updatedParticipantId, true);

			setTimeout(
				() => {
					$.set(highlightedParticipantId, null);
				},
				2000
			);
		}
	}

	// Delete Participant handlers
	function handleDeleteClick(event, participant) {
		event.stopPropagation();
		$.set(deletingParticipantId, participant.id, true);
		$.set(deletingParticipantName, participant.name, true);
	}

	function handleCancelDelete() {
		$.set(deletingParticipantId, null);
		$.set(deletingParticipantName, '');
	}

	async function handleConfirmDelete() {
		if (!$.get(deletingParticipantId)) return;

		$.set(isDeleteSubmitting, true);

		try {
			await deleteParticipant($.get(splitId), $.get(deletingParticipantId));
			await loadSplit($.get(splitId));

			addToast({
				type: 'success',
				message: 'Participant removed successfully',
				description: $.get(deletingParticipantName)
			});

			$.set(deletingParticipantId, null);
			$.set(deletingParticipantName, '');
		} catch(err) {
			if (err.status === 409) {
				addToast({
					type: 'error',
					message: `Cannot remove ${$.get(deletingParticipantName)} - they have associated expenses. Remove or reassign their expenses first.`
				});
			} else {
				addToast({
					type: 'error',
					message: err.detail || 'Failed to remove participant. Please try again.'
				});
			}

			$.set(deletingParticipantId, null);
			$.set(deletingParticipantName, '');
		} finally {
			$.set(isDeleteSubmitting, false);
		}
	}

	// Add Expense Modal handlers
	function handleAddExpenseClick(event, participant) {
		event.stopPropagation();
		$.set(selectedPayerId, participant.id, true);
		$.set(showAddExpenseModal, true);
	}

	function handleAddExpenseModalClose() {
		$.set(showAddExpenseModal, false);
		$.set(selectedPayerId, null);
	}

	async function handleAddExpenseSuccess() {
		await loadSplit($.get(splitId));
	}

	function handleDetailsClick(event, participant) {
		event.stopPropagation();
		$.set(selectedParticipantForExpenses, participant, true);
		$.set(showExpensesModal, true);
	}

	function handleExpensesModalClose() {
		$.set(showExpensesModal, false);
		$.set(selectedParticipantForExpenses, null);
	}

	var fragment = root();
	var div = $.first_child(fragment);
	var node = $.child(div);

	{
		var consequent = ($$anchor) => {
			{
				let $0 = $.derived(() => $.get(split) && $.get(split).participants.length === 0 ? () => 'no-participants' : undefined);

				SplitPageHeader($$anchor, {
					get splitName() {
						return $.get(splitDisplayName);
					},

					get splitId() {
						return $.get(splitId);
					},

					get navigateGuard() {
						return $.get($0);
					}
				});
			}
		};

		$.if(node, ($$render) => {
			if ($.get(splitId)) $$render(consequent);
		});
	}

	var node_1 = $.sibling(node, 2);

	{
		var consequent_1 = ($$anchor) => {
			var div_1 = root_2();

			$.append($$anchor, div_1);
		};

		var alternate_3 = ($$anchor) => {
			var fragment_2 = $.comment();
			var node_2 = $.first_child(fragment_2);

			{
				var consequent_15 = ($$anchor) => {
					var fragment_3 = root_4();
					var node_3 = $.first_child(fragment_3);

					{
						var consequent_2 = ($$anchor) => {
							var div_2 = root_5();
							var button = $.sibling($.child(div_2), 2);

							button.__click = () => navigate(`/splits/${$.get(splitId)}/settlement`);
							$.reset(div_2);
							$.append($$anchor, div_2);
						};

						$.if(node_3, ($$render) => {
							if ($.get(isSettled)) $$render(consequent_2);
						});
					}

					var node_4 = $.sibling(node_3, 2);

					ParticipantSummaryCard(node_4, {
						get participants() {
							return $.get(split).participants;
						},

						showTitle: false
					});

					var node_5 = $.sibling(node_4, 2);

					{
						var consequent_7 = ($$anchor) => {
							var fragment_4 = $.comment();
							var node_6 = $.first_child(fragment_4);

							$.component(node_6, () => Card.Root, ($$anchor, Card_Root) => {
								Card_Root($$anchor, {
									class: 'w-full',

									children: ($$anchor, $$slotProps) => {
										var fragment_5 = $.comment();
										var node_7 = $.first_child(fragment_5);

										$.component(node_7, () => Card.Content, ($$anchor, Card_Content) => {
											Card_Content($$anchor, {
												class: 'py-4',

												children: ($$anchor, $$slotProps) => {
													var form = root_8();
													var p_1 = $.child(form);
													var text = $.child(p_1, true);

													$.reset(p_1);

													var div_3 = $.sibling(p_1, 2);
													var node_8 = $.child(div_3);

													Label(node_8, {
														for: 'participant-name',

														children: ($$anchor, $$slotProps) => {
															$.next();

															var text_1 = $.text('Name');

															$.append($$anchor, text_1);
														},

														$$slots: { default: true }
													});

													var node_9 = $.sibling(node_8, 2);

													Input(node_9, {
														id: 'participant-name',
														type: 'text',
														placeholder: 'Enter name',
														oninput: validateNameOnInput,
														class: 'min-h-[44px]',

														get disabled() {
															return $.get(isSubmitting);
														},

														get value() {
															return $.get(formName);
														},

														set value($$value) {
															$.set(formName, $$value, true);
														},

														get ref() {
															return $.get(nameInputEl);
														},

														set ref($$value) {
															$.set(nameInputEl, $$value, true);
														}
													});

													var node_10 = $.sibling(node_9, 2);

													{
														var consequent_3 = ($$anchor) => {
															var p_2 = root_10();
															var text_2 = $.child(p_2, true);

															$.reset(p_2);
															$.template_effect(() => $.set_text(text_2, $.get(validationErrors).name));
															$.append($$anchor, p_2);
														};

														$.if(node_10, ($$render) => {
															if ($.get(validationErrors).name) $$render(consequent_3);
														});
													}

													$.reset(div_3);

													var div_4 = $.sibling(div_3, 2);
													var div_5 = $.child(div_4);
													var div_6 = $.child(div_5);
													var node_11 = $.child(div_6);

													Label(node_11, {
														for: 'participant-nights',

														children: ($$anchor, $$slotProps) => {
															$.next();

															var text_3 = $.text('Nights');

															$.append($$anchor, text_3);
														},

														$$slots: { default: true }
													});

													var button_1 = $.sibling(node_11, 2);

													button_1.__click = () => {
														$.set(activeFieldInfo, 'nights');
													};

													var node_12 = $.child(button_1);

													Info(node_12, { class: 'h-3.5 w-3.5' });
													$.reset(button_1);
													$.reset(div_6);

													var node_13 = $.sibling(div_6, 2);

													Input(node_13, {
														id: 'participant-nights',
														type: 'number',
														step: '1',
														min: '1',
														oninput: validateNightsOnInput,
														class: 'min-h-[44px]',

														get disabled() {
															return $.get(isSubmitting);
														},

														get value() {
															return $.get(formNights);
														},

														set value($$value) {
															$.set(formNights, $$value, true);
														}
													});

													var node_14 = $.sibling(node_13, 2);

													{
														var consequent_4 = ($$anchor) => {
															var p_3 = root_12();
															var text_4 = $.child(p_3, true);

															$.reset(p_3);
															$.template_effect(() => $.set_text(text_4, $.get(validationErrors).nights));
															$.append($$anchor, p_3);
														};

														$.if(node_14, ($$render) => {
															if ($.get(validationErrors).nights) $$render(consequent_4);
														});
													}

													$.reset(div_5);

													var node_15 = $.sibling(div_5, 2);

													{
														var consequent_6 = ($$anchor) => {
															var div_7 = root_13();
															var div_8 = $.child(div_7);
															var node_16 = $.child(div_8);

															Label(node_16, {
																for: 'participant-members',

																children: ($$anchor, $$slotProps) => {
																	$.next();

																	var text_5 = $.text('Members');

																	$.append($$anchor, text_5);
																},

																$$slots: { default: true }
															});

															var button_2 = $.sibling(node_16, 2);

															button_2.__click = () => {
																$.set(activeFieldInfo, 'members');
															};

															var node_17 = $.child(button_2);

															Info(node_17, { class: 'h-3.5 w-3.5' });
															$.reset(button_2);
															$.reset(div_8);

															var node_18 = $.sibling(div_8, 2);

															Input(node_18, {
																id: 'participant-members',
																type: 'number',
																step: 'any',
																min: '0.5',
																max: '50',
																oninput: validateMembersOnInput,

																onkeydown: (e) => {
																	if (e.key === 'ArrowUp') {
																		e.preventDefault();
																		$.set(formMembers, Math.min(50, Math.round(($.get(formMembers) + 0.5) * 100) / 100), true);
																		validateMembersOnInput();
																	} else if (e.key === 'ArrowDown') {
																		e.preventDefault();
																		$.set(formMembers, Math.max(0.5, Math.round(($.get(formMembers) - 0.5) * 100) / 100), true);
																		validateMembersOnInput();
																	}
																},

																class: 'min-h-[44px]',

																get disabled() {
																	return $.get(isSubmitting);
																},

																get value() {
																	return $.get(formMembers);
																},

																set value($$value) {
																	$.set(formMembers, $$value, true);
																}
															});

															var node_19 = $.sibling(node_18, 2);

															{
																var consequent_5 = ($$anchor) => {
																	var p_4 = root_15();
																	var text_6 = $.child(p_4, true);

																	$.reset(p_4);
																	$.template_effect(() => $.set_text(text_6, $.get(validationErrors).members));
																	$.append($$anchor, p_4);
																};

																$.if(node_19, ($$render) => {
																	if ($.get(validationErrors).members) $$render(consequent_5);
																});
															}

															$.reset(div_7);
															$.append($$anchor, div_7);
														};

														$.if(node_15, ($$render) => {
															if ($.get(addMode) === 'family') $$render(consequent_6);
														});
													}

													$.reset(div_4);

													var div_9 = $.sibling(div_4, 2);
													var node_20 = $.child(div_9);

													Button(node_20, {
														type: 'submit',

														get disabled() {
															return $.get(isSubmitting);
														},

														class: 'flex-1 min-h-[44px]',

														children: ($$anchor, $$slotProps) => {
															$.next();

															var text_7 = $.text();

															$.template_effect(() => $.set_text(text_7, $.get(isSubmitting) ? 'Adding...' : 'Add'));
															$.append($$anchor, text_7);
														},

														$$slots: { default: true }
													});

													var node_21 = $.sibling(node_20, 2);

													Button(node_21, {
														type: 'button',
														variant: 'outline',
														onclick: handleCancelAddForm,

														get disabled() {
															return $.get(isSubmitting);
														},

														class: 'flex-1 min-h-[44px]',

														children: ($$anchor, $$slotProps) => {
															$.next();

															var text_8 = $.text('Cancel');

															$.append($$anchor, text_8);
														},

														$$slots: { default: true }
													});

													$.reset(div_9);
													$.reset(form);
													$.template_effect(() => $.set_text(text, $.get(addMode) === 'family' ? 'New Family' : 'New Participant'));

													$.event('submit', form, (e) => {
														e.preventDefault();
														handleAddParticipant();
													});

													$.append($$anchor, form);
												},

												$$slots: { default: true }
											});
										});

										$.append($$anchor, fragment_5);
									},

									$$slots: { default: true }
								});
							});

							$.append($$anchor, fragment_4);
						};

						var alternate = ($$anchor) => {
							var fragment_7 = $.comment();
							var node_22 = $.first_child(fragment_7);

							{
								var consequent_8 = ($$anchor) => {
									var div_10 = root_19();
									var node_23 = $.child(div_10);

									Button(node_23, {
										onclick: handleShowSingleForm,
										variant: 'outline',
										class: 'sm:flex-1 min-h-[44px]',

										children: ($$anchor, $$slotProps) => {
											var fragment_8 = root_20();
											var node_24 = $.first_child(fragment_8);

											User(node_24, { class: 'h-4 w-4 mr-1' });
											$.next();
											$.append($$anchor, fragment_8);
										},

										$$slots: { default: true }
									});

									var div_11 = $.sibling(node_23, 2);
									var node_25 = $.child(div_11);

									Button(node_25, {
										onclick: handleShowFamilyForm,
										variant: 'outline',
										class: 'flex-1 sm:flex-1 min-h-[44px]',

										children: ($$anchor, $$slotProps) => {
											var fragment_9 = root_21();
											var node_26 = $.first_child(fragment_9);

											Users(node_26, { class: 'h-4 w-4 mr-1' });
											$.next();
											$.append($$anchor, fragment_9);
										},

										$$slots: { default: true }
									});

									var node_27 = $.sibling(node_25, 2);

									Button(node_27, {
										onclick: () => {
											$.set(showHelp, true);
										},

										variant: 'ghost',
										class: 'min-h-[44px] min-w-[44px] shrink-0 px-2',
										'aria-label': 'Help',

										children: ($$anchor, $$slotProps) => {
											HelpCircle($$anchor, { class: 'h-5 w-5 text-muted-foreground' });
										},

										$$slots: { default: true }
									});

									$.reset(div_11);
									$.reset(div_10);
									$.append($$anchor, div_10);
								};

								$.if(
									node_22,
									($$render) => {
										if (!$.get(isSettled)) $$render(consequent_8);
									},
									true
								);
							}

							$.append($$anchor, fragment_7);
						};

						$.if(node_5, ($$render) => {
							if (!$.get(isSettled) && $.get(addMode) !== null) $$render(consequent_7); else $$render(alternate, false);
						});
					}

					var node_28 = $.sibling(node_5, 2);

					{
						var consequent_9 = ($$anchor) => {
							var div_12 = root_23();

							$.append($$anchor, div_12);
						};

						$.if(node_28, ($$render) => {
							if ($.get(sortedParticipants).length === 0 && $.get(addMode) === null) $$render(consequent_9);
						});
					}

					var node_29 = $.sibling(node_28, 2);

					$.each(node_29, 17, () => $.get(sortedParticipants), (participant) => participant.id, ($$anchor, participant) => {
						const stats = $.derived(() => getParticipantStats($.get(participant).id));
						const sharedAccountPartners = $.derived(() => getSharedAccountPartners($.get(participant)));
						var fragment_11 = $.comment();
						var node_30 = $.first_child(fragment_11);

						$.component(node_30, () => Card.Root, ($$anchor, Card_Root_1) => {
							Card_Root_1($$anchor, {
								class: 'w-full',

								children: ($$anchor, $$slotProps) => {
									var fragment_12 = $.comment();
									var node_31 = $.first_child(fragment_12);

									{
										let $0 = $.derived(() => $.get(highlightedParticipantId) === $.get(participant).id ? 'bg-teal-50' : '');

										$.component(node_31, () => Card.Content, ($$anchor, Card_Content_1) => {
											Card_Content_1($$anchor, {
												get class() {
													return `py-4 transition-colors duration-500 ${$.get($0) ?? ''}`;
												},

												children: ($$anchor, $$slotProps) => {
													var div_13 = root_26();
													var div_14 = $.child(div_13);
													var span = $.child(div_14);
													var text_9 = $.child(span, true);

													$.reset(span);

													var div_15 = $.sibling(span, 2);
													var node_32 = $.child(div_15);

													{
														let $0 = $.derived(() => `View expenses for ${$.get(participant).name}`);

														Button(node_32, {
															variant: 'ghost',
															size: 'sm',
															onclick: (e) => handleDetailsClick(e, $.get(participant)),
															class: 'min-h-[44px] min-w-[44px]',

															get 'aria-label'() {
																return $.get($0);
															},

															children: ($$anchor, $$slotProps) => {
																List($$anchor, { class: 'h-4 w-4' });
															},

															$$slots: { default: true }
														});
													}

													var node_33 = $.sibling(node_32, 2);

													{
														var consequent_10 = ($$anchor) => {
															var fragment_14 = root_28();
															var node_34 = $.first_child(fragment_14);

															{
																let $0 = $.derived(() => `Add expense for ${$.get(participant).name}`);

																Button(node_34, {
																	variant: 'ghost',
																	size: 'sm',
																	onclick: (e) => handleAddExpenseClick(e, $.get(participant)),
																	class: 'text-primary hover:text-primary hover:bg-primary/10 min-h-[44px] min-w-[44px]',

																	get 'aria-label'() {
																		return $.get($0);
																	},

																	children: ($$anchor, $$slotProps) => {
																		Plus($$anchor, { class: 'h-4 w-4' });
																	},

																	$$slots: { default: true }
																});
															}

															var node_35 = $.sibling(node_34, 2);

															{
																let $0 = $.derived(() => `Edit ${$.get(participant).name}`);

																Button(node_35, {
																	variant: 'ghost',
																	size: 'sm',
																	onclick: () => handleStartEdit($.get(participant)),
																	class: 'min-h-[44px] min-w-[44px]',

																	get 'aria-label'() {
																		return $.get($0);
																	},

																	children: ($$anchor, $$slotProps) => {
																		var svg = root_30();

																		$.append($$anchor, svg);
																	},

																	$$slots: { default: true }
																});
															}

															var node_36 = $.sibling(node_35, 2);

															{
																let $0 = $.derived(() => `Delete ${$.get(participant).name}`);

																Button(node_36, {
																	variant: 'ghost',
																	size: 'sm',
																	onclick: (e) => handleDeleteClick(e, $.get(participant)),
																	class: 'text-destructive hover:text-destructive hover:bg-destructive/10 min-h-[44px] min-w-[44px]',

																	get 'aria-label'() {
																		return $.get($0);
																	},

																	children: ($$anchor, $$slotProps) => {
																		var svg_1 = root_31();

																		$.append($$anchor, svg_1);
																	},

																	$$slots: { default: true }
																});
															}

															$.append($$anchor, fragment_14);
														};

														$.if(node_33, ($$render) => {
															if (!$.get(isSettled)) $$render(consequent_10);
														});
													}

													$.reset(div_15);
													$.reset(div_14);

													var div_16 = $.sibling(div_14, 2);
													var span_1 = $.child(div_16);
													var text_10 = $.child(span_1);

													$.reset(span_1);

													var node_37 = $.sibling(span_1, 2);

													{
														var consequent_11 = ($$anchor) => {
															var span_2 = root_32();
															var text_11 = $.child(span_2);

															$.reset(span_2);
															$.template_effect(() => $.set_text(text_11, `${$.get(participant).share ?? ''} ${$.get(participant).share <= 1 ? 'share' : 'shares'}`));
															$.append($$anchor, span_2);
														};

														$.if(node_37, ($$render) => {
															if ($.get(participant).share > 1) $$render(consequent_11);
														});
													}

													var span_3 = $.sibling(node_37, 2);
													var text_12 = $.child(span_3);

													$.reset(span_3);

													var node_38 = $.sibling(span_3, 2);

													{
														var consequent_12 = ($$anchor) => {
															var span_4 = root_33();
															var node_39 = $.child(span_4);

															Users(node_39, { class: 'h-3 w-3 shrink-0' });

															var text_13 = $.sibling(node_39);

															$.reset(span_4);
															$.template_effect(($0) => $.set_text(text_13, ` ${$0 ?? ''}`), [() => $.get(sharedAccountPartners).join(' & ')]);
															$.append($$anchor, span_4);
														};

														$.if(node_38, ($$render) => {
															if ($.get(sharedAccountPartners)) $$render(consequent_12);
														});
													}

													$.reset(div_16);

													var div_17 = $.sibling(div_16, 2);
													var span_5 = $.child(div_17);
													var node_40 = $.child(span_5);

													Wallet(node_40, { class: 'h-4 w-4 shrink-0' });

													var span_6 = $.sibling(node_40, 2);
													var text_14 = $.child(span_6, true);

													$.reset(span_6);
													$.reset(span_5);

													var span_7 = $.sibling(span_5, 2);
													var node_41 = $.child(span_7);

													Receipt(node_41, { class: 'h-4 w-4 shrink-0' });

													var span_8 = $.sibling(node_41, 2);
													var text_15 = $.child(span_8, true);

													$.reset(span_8);
													$.reset(span_7);

													var span_9 = $.sibling(span_7, 2);
													var node_42 = $.child(span_9);

													{
														var consequent_13 = ($$anchor) => {
															var fragment_16 = root_34();
															var node_43 = $.first_child(fragment_16);

															TrendingUp(node_43, { class: 'h-4 w-4 shrink-0' });

															var span_10 = $.sibling(node_43, 2);
															var text_16 = $.child(span_10, true);

															$.reset(span_10);
															$.template_effect(($0) => $.set_text(text_16, $0), [() => formatCurrency($.get(stats).balance)]);
															$.append($$anchor, fragment_16);
														};

														var alternate_2 = ($$anchor) => {
															var fragment_17 = $.comment();
															var node_44 = $.first_child(fragment_17);

															{
																var consequent_14 = ($$anchor) => {
																	var fragment_18 = root_36();
																	var node_45 = $.first_child(fragment_18);

																	TrendingDown(node_45, { class: 'h-4 w-4 shrink-0' });

																	var span_11 = $.sibling(node_45, 2);
																	var text_17 = $.child(span_11, true);

																	$.reset(span_11);
																	$.template_effect(($0) => $.set_text(text_17, $0), [() => formatCurrency(Math.abs($.get(stats).balance))]);
																	$.append($$anchor, fragment_18);
																};

																var alternate_1 = ($$anchor) => {
																	var fragment_19 = root_37();
																	var node_46 = $.first_child(fragment_19);

																	Minus(node_46, { class: 'h-4 w-4 shrink-0' });
																	$.next(2);
																	$.append($$anchor, fragment_19);
																};

																$.if(
																	node_44,
																	($$render) => {
																		if ($.get(stats).balance < -0.005) $$render(consequent_14); else $$render(alternate_1, false);
																	},
																	true
																);
															}

															$.append($$anchor, fragment_17);
														};

														$.if(node_42, ($$render) => {
															if ($.get(stats).balance > 0.005) $$render(consequent_13); else $$render(alternate_2, false);
														});
													}

													$.reset(span_9);
													$.reset(div_17);
													$.reset(div_13);

													$.template_effect(
														($0, $1, $2, $3) => {
															$.set_text(text_9, $0);
															$.set_text(text_10, `${$.get(participant).nights ?? ''} ${$.get(participant).nights <= 1 ? 'night' : 'nights'}`);
															$.set_text(text_12, `${$.get(stats).expenseCount ?? ''} ${$.get(stats).expenseCount === 1 ? 'expense' : 'expenses'}`);
															$.set_text(text_14, $1);
															$.set_text(text_15, $2);
															$.set_class(span_9, 1, `flex items-center gap-1 ${$3 ?? ''}`);
														},
														[
															() => formatName($.get(participant).name),
															() => formatCurrency($.get(stats).spent),
															() => formatCurrency($.get(stats).cost),
															() => balanceColorClass($.get(stats).balance)
														]
													);

													$.append($$anchor, div_13);
												},

												$$slots: { default: true }
											});
										});
									}

									$.append($$anchor, fragment_12);
								},

								$$slots: { default: true }
							});
						});

						$.append($$anchor, fragment_11);
					});

					$.append($$anchor, fragment_3);
				};

				$.if(
					node_2,
					($$render) => {
						if (!$.get(isLoading) && $.get(split)) $$render(consequent_15);
					},
					true
				);
			}

			$.append($$anchor, fragment_2);
		};

		$.if(node_1, ($$render) => {
			if ($.get(showLoading)) $$render(consequent_1); else $$render(alternate_3, false);
		});
	}

	$.reset(div);

	var node_47 = $.sibling(div, 2);

	{
		let $0 = $.derived(() => !!$.get(deletingParticipantId));
		let $1 = $.derived(() => `Remove ${$.get(deletingParticipantName)}?`);

		ConfirmDialog(node_47, {
			get open() {
				return $.get($0);
			},

			get title() {
				return $.get($1);
			},

			description: 'This cannot be undone.',
			confirmLabel: 'Remove',
			cancelLabel: 'Cancel',
			onConfirm: handleConfirmDelete,
			onCancel: handleCancelDelete,

			get isLoading() {
				return $.get(isDeleteSubmitting);
			}
		});
	}

	var node_48 = $.sibling(node_47, 2);

	{
		var consequent_16 = ($$anchor) => {
			ExpenseEditModal($$anchor, {
				get open() {
					return $.get(showAddExpenseModal);
				},

				get splitId() {
					return $.get(split).id;
				},

				get preselectedPayerId() {
					return $.get(selectedPayerId);
				},

				get participants() {
					return $.get(split).participants;
				},

				onClose: handleAddExpenseModalClose,
				onSuccess: handleAddExpenseSuccess
			});
		};

		$.if(node_48, ($$render) => {
			if ($.get(split)) $$render(consequent_16);
		});
	}

	var node_49 = $.sibling(node_48, 2);

	{
		var consequent_17 = ($$anchor) => {
			var div_18 = root_39();

			div_18.__click = () => {
				$.set(activeFieldInfo, null);
			};

			var div_19 = $.child(div_18);

			div_19.__click = (e) => e.stopPropagation();

			var div_20 = $.child(div_19);
			var h2 = $.child(div_20);
			var text_18 = $.child(h2, true);

			$.reset(h2);

			var node_50 = $.sibling(h2, 2);

			Button(node_50, {
				variant: 'ghost',
				size: 'sm',

				onclick: () => {
					$.set(activeFieldInfo, null);
				},

				class: 'min-h-[44px] min-w-[44px]',
				'aria-label': 'Close',

				children: ($$anchor, $$slotProps) => {
					X($$anchor, { class: 'h-4 w-4' });
				},

				$$slots: { default: true }
			});

			$.reset(div_20);

			var div_21 = $.sibling(div_20, 2);

			$.each(div_21, 21, () => fieldInfo[$.get(activeFieldInfo)].description.split('\n\n'), $.index, ($$anchor, paragraph) => {
				var p_5 = root_41();
				var text_19 = $.child(p_5, true);

				$.reset(p_5);
				$.template_effect(() => $.set_text(text_19, $.get(paragraph)));
				$.append($$anchor, p_5);
			});

			$.reset(div_21);

			var div_22 = $.sibling(div_21, 2);
			var node_51 = $.child(div_22);

			Button(node_51, {
				onclick: () => {
					$.set(activeFieldInfo, null);
				},

				class: 'w-full min-h-[44px]',

				children: ($$anchor, $$slotProps) => {
					$.next();

					var text_20 = $.text('Got it');

					$.append($$anchor, text_20);
				},

				$$slots: { default: true }
			});

			$.reset(div_22);
			$.reset(div_19);
			$.reset(div_18);
			$.template_effect(() => $.set_text(text_18, fieldInfo[$.get(activeFieldInfo)].title));
			$.append($$anchor, div_18);
		};

		$.if(node_49, ($$render) => {
			if ($.get(activeFieldInfo)) $$render(consequent_17);
		});
	}

	var node_52 = $.sibling(node_49, 2);

	{
		var consequent_18 = ($$anchor) => {
			EditParticipantModal($$anchor, {
				get open() {
					return $.get(showEditParticipantModal);
				},

				get splitId() {
					return $.get(split).id;
				},

				get participant() {
					return $.get(editingParticipant);
				},

				get participants() {
					return $.get(split).participants;
				},

				get split() {
					return $.get(split);
				},

				onClose: handleEditModalClose,
				onSuccess: handleEditSuccess
			});
		};

		$.if(node_52, ($$render) => {
			if ($.get(split)) $$render(consequent_18);
		});
	}

	var node_53 = $.sibling(node_52, 2);

	{
		var consequent_19 = ($$anchor) => {
			ParticipantExpensesModal($$anchor, {
				get open() {
					return $.get(showExpensesModal);
				},

				get participant() {
					return $.get(selectedParticipantForExpenses);
				},

				get expenses() {
					return $.get(split).expenses;
				},

				get participants() {
					return $.get(split).participants;
				},

				onClose: handleExpensesModalClose
			});
		};

		$.if(node_53, ($$render) => {
			if ($.get(split) && $.get(selectedParticipantForExpenses)) $$render(consequent_19);
		});
	}

	var node_54 = $.sibling(node_53, 2);

	{
		var consequent_20 = ($$anchor) => {
			var div_23 = root_45();

			div_23.__click = () => {
				$.set(showHelp, false);
			};

			var div_24 = $.child(div_23);

			div_24.__click = (e) => e.stopPropagation();

			var div_25 = $.child(div_24);
			var node_55 = $.sibling($.child(div_25), 2);

			Button(node_55, {
				variant: 'ghost',
				size: 'sm',

				onclick: () => {
					$.set(showHelp, false);
				},

				class: 'min-h-[44px] min-w-[44px]',
				'aria-label': 'Close',

				children: ($$anchor, $$slotProps) => {
					X($$anchor, { class: 'h-4 w-4' });
				},

				$$slots: { default: true }
			});

			$.reset(div_25);

			var div_26 = $.sibling(div_25, 2);
			var div_27 = $.child(div_26);
			var p_6 = $.child(div_27);
			var node_56 = $.child(p_6);

			User(node_56, { class: 'h-4 w-4 text-teal-600' });
			$.next();
			$.reset(p_6);
			$.next(4);
			$.reset(div_27);

			var div_28 = $.sibling(div_27, 2);
			var p_7 = $.child(div_28);
			var node_57 = $.child(p_7);

			Users(node_57, { class: 'h-4 w-4 text-blue-600' });
			$.next();
			$.reset(p_7);
			$.next(4);
			$.reset(div_28);
			$.next(2);
			$.reset(div_26);

			var div_29 = $.sibling(div_26, 2);
			var node_58 = $.child(div_29);

			Button(node_58, {
				onclick: () => {
					$.set(showHelp, false);
				},

				class: 'w-full min-h-[44px]',

				children: ($$anchor, $$slotProps) => {
					$.next();

					var text_21 = $.text('Got it');

					$.append($$anchor, text_21);
				},

				$$slots: { default: true }
			});

			$.reset(div_29);
			$.reset(div_24);
			$.reset(div_23);
			$.append($$anchor, div_23);
		};

		$.if(node_54, ($$render) => {
			if ($.get(showHelp)) $$render(consequent_20);
		});
	}

	$.append($$anchor, fragment);
	$.pop();
}

$.delegate(['click']);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiUGFydGljaXBhbnRzLnN2ZWx0ZSJdLCJzb3VyY2VzQ29udGVudCI6WyIgPHNjcmlwdCBsYW5nPVwidHNcIj5cbiAgLy8gUGFydGljaXBhbnRzIEVkaXRpb24gUGFnZVxuXG4gIGltcG9ydCB7IGdldFNwbGl0LCBhZGRQYXJ0aWNpcGFudCwgZGVsZXRlUGFydGljaXBhbnQsIHR5cGUgU3BsaXQsIHR5cGUgUGFydGljaXBhbnQgfSBmcm9tICckbGliL2FwaS9zcGxpdHMnO1xuICBpbXBvcnQgdHlwZSB7IEFwaUVycm9yIH0gZnJvbSAnJGxpYi9hcGkvY2xpZW50JztcbiAgaW1wb3J0IEJ1dHRvbiBmcm9tICckbGliL2NvbXBvbmVudHMvdWkvYnV0dG9uL2J1dHRvbi5zdmVsdGUnO1xuICBpbXBvcnQgKiBhcyBDYXJkIGZyb20gJyRsaWIvY29tcG9uZW50cy91aS9jYXJkJztcbiAgaW1wb3J0IElucHV0IGZyb20gJyRsaWIvY29tcG9uZW50cy91aS9pbnB1dC9pbnB1dC5zdmVsdGUnO1xuICBpbXBvcnQgTGFiZWwgZnJvbSAnJGxpYi9jb21wb25lbnRzL3VpL2xhYmVsL2xhYmVsLnN2ZWx0ZSc7XG4gIGltcG9ydCBDb25maXJtRGlhbG9nIGZyb20gJyRsaWIvY29tcG9uZW50cy91aS9jb25maXJtLWRpYWxvZy9jb25maXJtLWRpYWxvZy5zdmVsdGUnO1xuICBpbXBvcnQgRXhwZW5zZUVkaXRNb2RhbCBmcm9tICckbGliL2NvbXBvbmVudHMvZXhwZW5zZS9FeHBlbnNlRWRpdE1vZGFsLnN2ZWx0ZSc7XG4gIGltcG9ydCBFZGl0UGFydGljaXBhbnRNb2RhbCBmcm9tICckbGliL2NvbXBvbmVudHMvcGFydGljaXBhbnQvRWRpdFBhcnRpY2lwYW50TW9kYWwuc3ZlbHRlJztcbiAgaW1wb3J0IFBhcnRpY2lwYW50RXhwZW5zZXNNb2RhbCBmcm9tICckbGliL2NvbXBvbmVudHMvcGFydGljaXBhbnQvUGFydGljaXBhbnRFeHBlbnNlc01vZGFsLnN2ZWx0ZSc7XG4gIGltcG9ydCBQYXJ0aWNpcGFudFN1bW1hcnlDYXJkIGZyb20gJyRsaWIvY29tcG9uZW50cy9wYXJ0aWNpcGFudC9QYXJ0aWNpcGFudFN1bW1hcnlDYXJkLnN2ZWx0ZSc7XG4gIGltcG9ydCB7IGFkZFRvYXN0IH0gZnJvbSAnJGxpYi9zdG9yZXMvdG9hc3RTdG9yZS5zdmVsdGUnO1xuICBpbXBvcnQgeyByb3V0ZSwgbmF2aWdhdGUgfSBmcm9tICckbGliL3JvdXRlcic7XG4gIGltcG9ydCB7IGxvYWROaWdodHNEZWZhdWx0LCBzYXZlTmlnaHRzRGVmYXVsdCB9IGZyb20gJyRsaWIvc3RvcmVzL25pZ2h0c0RlZmF1bHRTdG9yZSc7XG4gIGltcG9ydCB7IFVzZXIsIFBsdXMsIFdhbGxldCwgUmVjZWlwdCwgVHJlbmRpbmdVcCwgVHJlbmRpbmdEb3duLCBNaW51cywgSW5mbywgWCwgVXNlcnMsIEhlbHBDaXJjbGUsIExpc3QgfSBmcm9tICckbGliL2ljb25zJztcblxuICAvLyBGaWVsZCBpbmZvIG1vZGFsIHN0YXRlIChhZGQgZm9ybSlcbiAgbGV0IGFjdGl2ZUZpZWxkSW5mbyA9ICRzdGF0ZTwnbmlnaHRzJyB8ICdtZW1iZXJzJyB8IG51bGw+KG51bGwpO1xuXG4gIC8vIEhlbHAgbW9kYWwgc3RhdGVcbiAgbGV0IHNob3dIZWxwID0gJHN0YXRlKGZhbHNlKTtcblxuICBjb25zdCBmaWVsZEluZm8gPSB7XG4gICAgbmlnaHRzOiB7XG4gICAgICB0aXRsZTogJ05pZ2h0cycsXG4gICAgICBkZXNjcmlwdGlvbjogYFRoZSBudW1iZXIgb2YgbmlnaHRzIHRoaXMgcGFydGljaXBhbnQgc3RheXMgZHVyaW5nIHRoZSB0cmlwLlxcblxcblVzZWQgaW4gdGhlIFwiQnkgTmlnaHRcIiBzcGxpdCBtb2RlOiBjb3N0cyBhcmUgZGl2aWRlZCBwcm9wb3J0aW9uYWxseSBiYXNlZCBvbiBlYWNoIHBhcnRpY2lwYW50J3MgbmlnaHRzIMOXIHNoYXJlIHdlaWdodC5cXG5cXG5FeGFtcGxlOiBhIHBhcnRpY2lwYW50IHN0YXlpbmcgMyBuaWdodHMgb3V0IG9mIGEgNy1uaWdodCB0cmlwIHBheXMgZm9yIDMvNyBvZiB0aGUgbmlnaHQtYmFzZWQgZXhwZW5zZXMgKGFkanVzdGVkIGJ5IHRoZWlyIHNoYXJlKS5gLFxuICAgIH0sXG4gICAgbWVtYmVyczoge1xuICAgICAgdGl0bGU6ICdNZW1iZXJzJyxcbiAgICAgIGRlc2NyaXB0aW9uOiBgVGhlIG51bWJlciBvZiBwZW9wbGUgaW4gdGhpcyBmYW1pbHkgZ3JvdXAuXFxuXFxuQWR1bHRzIGNvdW50IGFzIDEgZWFjaC4gQ2hpbGRyZW4gY2FuIGNvdW50IGZvciAwLjUgdG8gcmVmbGVjdCB0aGVpciBsb3dlciBjb25zdW1wdGlvbi5cXG5cXG5FeGFtcGxlOiBhIGZhbWlseSBvZiAyIGFkdWx0cyBhbmQgMiBjaGlsZHJlbiBzdGF5aW5nIDcgbmlnaHRzIOKGkiAzIG1lbWJlcnMgKDIgw5cgMSArIDIgw5cgMC41KS5cXG5cXG5JZiBvbmUgcGFyZW50IGxlYXZlcyBlYXJseSAoZS5nLiBzdGF5cyBvbmx5IDMgbmlnaHRzKSwgYWRkIHRoZW0gYXMgYSBzZXBhcmF0ZSBzaW5nbGUgcGFydGljaXBhbnQgd2l0aCAzIG5pZ2h0cyBhbmQgYSBzaGFyZSBvZiAxLiBUaGUgcmVzdCBvZiB0aGUgZmFtaWx5IGNhbiB0aGVuIGJlIGVudGVyZWQgd2l0aCBmZXdlciBtZW1iZXJzLmAsXG4gICAgfSxcbiAgfTtcbiAgaW1wb3J0IFNwbGl0UGFnZUhlYWRlciBmcm9tICckbGliL2NvbXBvbmVudHMvdWkvc3BsaXQtcGFnZS1oZWFkZXIvU3BsaXRQYWdlSGVhZGVyLnN2ZWx0ZSc7XG4gIGltcG9ydCB7IGdldENhY2hlZFNwbGl0TmFtZSwgc2V0Q2FjaGVkU3BsaXROYW1lIH0gZnJvbSAnJGxpYi9zdG9yZXMvc3BsaXRUaXRsZUNhY2hlJztcbiAgaW1wb3J0IHsgdGljayB9IGZyb20gJ3N2ZWx0ZSc7XG5cbiAgY29uc3Qgc3BsaXRJZCA9ICRkZXJpdmVkKHJvdXRlLnBhcmFtcy5zcGxpdElkIHx8ICcnKTtcblxuICAvLyBTdGF0ZVxuICBsZXQgc3BsaXQgPSAkc3RhdGU8U3BsaXQgfCBudWxsPihudWxsKTtcbiAgbGV0IHNwbGl0RGlzcGxheU5hbWUgPSAkc3RhdGUoZ2V0Q2FjaGVkU3BsaXROYW1lKHJvdXRlLnBhcmFtcy5zcGxpdElkIHx8ICcnKSk7XG4gIGNvbnN0IHNvcnRlZFBhcnRpY2lwYW50cyA9ICRkZXJpdmVkKFxuICAgIHNwbGl0Py5wYXJ0aWNpcGFudHMuc2xpY2UoKS5zb3J0KChhLCBiKSA9PiBhLm5hbWUubG9jYWxlQ29tcGFyZShiLm5hbWUpKSA/PyBbXVxuICApO1xuICBjb25zdCBpc1NldHRsZWQgPSAkZGVyaXZlZChzcGxpdD8uc2V0dGxlbWVudCAhPSBudWxsKTtcbiAgbGV0IGlzTG9hZGluZyA9ICRzdGF0ZSh0cnVlKTtcbiAgbGV0IHNob3dMb2FkaW5nID0gJHN0YXRlKGZhbHNlKTtcbiAgbGV0IGxvYWRpbmdUaW1lcjogUmV0dXJuVHlwZTx0eXBlb2Ygc2V0VGltZW91dD4gfCBudWxsID0gbnVsbDtcblxuICAvLyBBZGQgUGFydGljaXBhbnQgZm9ybSBzdGF0ZVxuICBsZXQgYWRkTW9kZSA9ICRzdGF0ZTwnc2luZ2xlJyB8ICdmYW1pbHknIHwgbnVsbD4obnVsbCk7XG4gIGxldCBuYW1lSW5wdXRFbCA9ICRzdGF0ZTxIVE1MSW5wdXRFbGVtZW50IHwgbnVsbD4obnVsbCk7XG4gIGxldCBmb3JtTmFtZSA9ICRzdGF0ZSgnJyk7XG4gIGxldCBmb3JtTmlnaHRzID0gJHN0YXRlKDEpO1xuICBsZXQgZm9ybU1lbWJlcnMgPSAkc3RhdGUoMSk7XG4gIGxldCB2YWxpZGF0aW9uRXJyb3JzID0gJHN0YXRlPHtuYW1lPzogc3RyaW5nOyBuaWdodHM/OiBzdHJpbmc7IG1lbWJlcnM/OiBzdHJpbmd9Pih7fSk7XG4gIGxldCBpc1N1Ym1pdHRpbmcgPSAkc3RhdGUoZmFsc2UpO1xuXG4gIC8vIEVkaXQgUGFydGljaXBhbnQgc3RhdGVcbiAgbGV0IHNob3dFZGl0UGFydGljaXBhbnRNb2RhbCA9ICRzdGF0ZShmYWxzZSk7XG4gIGxldCBlZGl0aW5nUGFydGljaXBhbnQgPSAkc3RhdGU8UGFydGljaXBhbnQgfCBudWxsPihudWxsKTtcbiAgbGV0IGhpZ2hsaWdodGVkUGFydGljaXBhbnRJZCA9ICRzdGF0ZTxzdHJpbmcgfCBudWxsPihudWxsKTtcblxuICAvLyBEZWxldGUgUGFydGljaXBhbnQgc3RhdGVcbiAgbGV0IGRlbGV0aW5nUGFydGljaXBhbnRJZCA9ICRzdGF0ZTxzdHJpbmcgfCBudWxsPihudWxsKTtcbiAgbGV0IGRlbGV0aW5nUGFydGljaXBhbnROYW1lID0gJHN0YXRlKCcnKTtcbiAgbGV0IGlzRGVsZXRlU3VibWl0dGluZyA9ICRzdGF0ZShmYWxzZSk7XG5cbiAgLy8gQWRkIEV4cGVuc2UgTW9kYWwgc3RhdGVcbiAgbGV0IHNob3dBZGRFeHBlbnNlTW9kYWwgPSAkc3RhdGUoZmFsc2UpO1xuICBsZXQgc2VsZWN0ZWRQYXllcklkID0gJHN0YXRlPHN0cmluZyB8IG51bGw+KG51bGwpO1xuXG4gIC8vIFBhcnRpY2lwYW50IEV4cGVuc2VzIE1vZGFsIHN0YXRlXG4gIGxldCBzaG93RXhwZW5zZXNNb2RhbCA9ICRzdGF0ZShmYWxzZSk7XG4gIGxldCBzZWxlY3RlZFBhcnRpY2lwYW50Rm9yRXhwZW5zZXMgPSAkc3RhdGU8UGFydGljaXBhbnQgfCBudWxsPihudWxsKTtcblxuXG4gIC8vIExvYWQgc3BsaXQgZGF0YVxuICAkZWZmZWN0KCgpID0+IHtcbiAgICBpZiAoc3BsaXRJZCkge1xuICAgICAgbG9hZFNwbGl0KHNwbGl0SWQpO1xuICAgIH1cbiAgfSk7XG5cbiAgYXN5bmMgZnVuY3Rpb24gbG9hZFNwbGl0KGlkOiBzdHJpbmcpIHtcbiAgICBpc0xvYWRpbmcgPSB0cnVlO1xuICAgIHNob3dMb2FkaW5nID0gZmFsc2U7XG5cbiAgICBpZiAobG9hZGluZ1RpbWVyKSBjbGVhclRpbWVvdXQobG9hZGluZ1RpbWVyKTtcbiAgICBsb2FkaW5nVGltZXIgPSBzZXRUaW1lb3V0KCgpID0+IHsgc2hvd0xvYWRpbmcgPSB0cnVlOyB9LCA1MDApO1xuXG4gICAgdHJ5IHtcbiAgICAgIHNwbGl0ID0gYXdhaXQgZ2V0U3BsaXQoaWQpO1xuICAgICAgc3BsaXREaXNwbGF5TmFtZSA9IHNwbGl0Lm5hbWU7XG4gICAgICBzZXRDYWNoZWRTcGxpdE5hbWUoaWQsIHNwbGl0Lm5hbWUpO1xuICAgIH0gY2F0Y2ggKGVycikge1xuICAgICAgY29uc3QgYXBpRXJyb3IgPSBlcnIgYXMgQXBpRXJyb3I7XG4gICAgICBpZiAoYXBpRXJyb3Iuc3RhdHVzID09PSA0MDQgfHwgYXBpRXJyb3Iuc3RhdHVzID09PSA0MDApIHtcbiAgICAgICAgYWRkVG9hc3QoeyB0eXBlOiAnaW5mbycsIG1lc3NhZ2U6ICdTcGxpdCBub3QgZm91bmQg4oCUIGNyZWF0ZSBhIG5ldyBvbmUuJyB9KTtcbiAgICAgICAgbmF2aWdhdGUoJy8nKTtcbiAgICAgIH0gZWxzZSB7XG4gICAgICAgIGFkZFRvYXN0KHtcbiAgICAgICAgICB0eXBlOiAnZXJyb3InLFxuICAgICAgICAgIG1lc3NhZ2U6IGFwaUVycm9yLmRldGFpbCB8fCAnRmFpbGVkIHRvIGxvYWQgcGFydGljaXBhbnRzJyxcbiAgICAgICAgfSk7XG4gICAgICB9XG4gICAgfSBmaW5hbGx5IHtcbiAgICAgIGlzTG9hZGluZyA9IGZhbHNlO1xuICAgICAgc2hvd0xvYWRpbmcgPSBmYWxzZTtcbiAgICAgIGlmIChsb2FkaW5nVGltZXIpIHsgY2xlYXJUaW1lb3V0KGxvYWRpbmdUaW1lcik7IGxvYWRpbmdUaW1lciA9IG51bGw7IH1cbiAgICB9XG4gIH1cblxuICAvLyBQZXItcGFydGljaXBhbnQgc3RhdHMgY2FsY3VsYXRpb25cbiAgZnVuY3Rpb24gZ2V0UGFydGljaXBhbnRTdGF0cyhwYXJ0aWNpcGFudElkOiBzdHJpbmcpIHtcbiAgICBpZiAoIXNwbGl0KSByZXR1cm4geyBzcGVudDogMCwgY29zdDogMCwgYmFsYW5jZTogMCwgZXhwZW5zZUNvdW50OiAwIH07XG5cbiAgICBjb25zdCBzcGVudCA9IHNwbGl0LmV4cGVuc2VzXG4gICAgICAuZmlsdGVyKGUgPT4gZS5wYXllcklkID09PSBwYXJ0aWNpcGFudElkKVxuICAgICAgLnJlZHVjZSgoc3VtLCBlKSA9PiBzdW0gKyBlLmFtb3VudCwgMCk7XG5cbiAgICBjb25zdCBjb3N0ID0gc3BsaXQuZXhwZW5zZXNcbiAgICAgIC5yZWR1Y2UoKHN1bSwgZSkgPT4ge1xuICAgICAgICBjb25zdCBzaGFyZSA9IGUuc2hhcmVzLmZpbmQocyA9PiBzLnBhcnRpY2lwYW50SWQgPT09IHBhcnRpY2lwYW50SWQpO1xuICAgICAgICByZXR1cm4gc3VtICsgKHNoYXJlPy5hbW91bnQgfHwgMCk7XG4gICAgICB9LCAwKTtcblxuICAgIGNvbnN0IGV4cGVuc2VDb3VudCA9IHNwbGl0LmV4cGVuc2VzXG4gICAgICAuZmlsdGVyKGUgPT4gZS5wYXllcklkID09PSBwYXJ0aWNpcGFudElkKVxuICAgICAgLmxlbmd0aDtcblxuICAgIGNvbnN0IGJhbGFuY2UgPSBzcGVudCAtIGNvc3Q7XG4gICAgcmV0dXJuIHsgc3BlbnQsIGNvc3QsIGJhbGFuY2UsIGV4cGVuc2VDb3VudCB9O1xuICB9XG5cbiAgZnVuY3Rpb24gZm9ybWF0TmFtZShuYW1lOiBzdHJpbmcpOiBzdHJpbmcge1xuICAgIGlmICghbmFtZSkgcmV0dXJuIG5hbWU7XG4gICAgcmV0dXJuIG5hbWUuY2hhckF0KDApLnRvVXBwZXJDYXNlKCkgKyBuYW1lLnNsaWNlKDEpLnRvTG93ZXJDYXNlKCk7XG4gIH1cblxuICBmdW5jdGlvbiBmb3JtYXRDdXJyZW5jeShhbW91bnQ6IG51bWJlcik6IHN0cmluZyB7XG4gICAgcmV0dXJuIG5ldyBJbnRsLk51bWJlckZvcm1hdCgnZW4tSUUnLCB7XG4gICAgICBzdHlsZTogJ2N1cnJlbmN5JyxcbiAgICAgIGN1cnJlbmN5OiAnRVVSJyxcbiAgICB9KS5mb3JtYXQoYW1vdW50KTtcbiAgfVxuXG4gIGZ1bmN0aW9uIGJhbGFuY2VDb2xvckNsYXNzKGJhbGFuY2U6IG51bWJlcik6IHN0cmluZyB7XG4gICAgaWYgKGJhbGFuY2UgPiAwLjAwNSkgcmV0dXJuICd0ZXh0LWdyZWVuLTYwMCc7XG4gICAgaWYgKGJhbGFuY2UgPCAtMC4wMDUpIHJldHVybiAndGV4dC1yZWQtNjAwJztcbiAgICByZXR1cm4gJ3RleHQtbXV0ZWQtZm9yZWdyb3VuZCc7XG4gIH1cblxuICBmdW5jdGlvbiBiYWxhbmNlTGFiZWwoYmFsYW5jZTogbnVtYmVyKTogc3RyaW5nIHtcbiAgICBpZiAoYmFsYW5jZSA+IDAuMDA1KSByZXR1cm4gYE93ZWQgJHtmb3JtYXRDdXJyZW5jeShiYWxhbmNlKX1gO1xuICAgIGlmIChiYWxhbmNlIDwgLTAuMDA1KSByZXR1cm4gYE93ZXMgJHtmb3JtYXRDdXJyZW5jeShNYXRoLmFicyhiYWxhbmNlKSl9YDtcbiAgICByZXR1cm4gJ1NldHRsZWQnO1xuICB9XG5cblxuICAvLyBSZXR1cm5zIHRoZSBuYW1lcyBvZiBjby1tZW1iZXJzIGluIHRoZSBzYW1lIHNoYXJlZCBhY2NvdW50IGdyb3VwLCBvciBudWxsIGlmIG5vdCBncm91cGVkLlxuICBmdW5jdGlvbiBnZXRTaGFyZWRBY2NvdW50UGFydG5lcnMocGFydGljaXBhbnQ6IFBhcnRpY2lwYW50KTogc3RyaW5nW10gfCBudWxsIHtcbiAgICBpZiAoIXBhcnRpY2lwYW50LnNoYXJlZEFjY291bnRJZCB8fCAhc3BsaXQpIHJldHVybiBudWxsO1xuICAgIGNvbnN0IHBhcnRuZXJzID0gc3BsaXQucGFydGljaXBhbnRzXG4gICAgICAuZmlsdGVyKHAgPT4gcC5pZCAhPT0gcGFydGljaXBhbnQuaWQgJiYgcC5zaGFyZWRBY2NvdW50SWQgPT09IHBhcnRpY2lwYW50LnNoYXJlZEFjY291bnRJZClcbiAgICAgIC5tYXAocCA9PiBwLm5hbWUpXG4gICAgICAuc29ydCgpO1xuICAgIHJldHVybiBwYXJ0bmVycy5sZW5ndGggPiAwID8gcGFydG5lcnMgOiBudWxsO1xuICB9XG5cbiAgLy8gQWRkIFBhcnRpY2lwYW50IGhhbmRsZXJzXG4gIGFzeW5jIGZ1bmN0aW9uIGhhbmRsZVNob3dTaW5nbGVGb3JtKCkge1xuICAgIGFkZE1vZGUgPSAnc2luZ2xlJztcbiAgICBmb3JtTmFtZSA9ICcnO1xuICAgIGZvcm1OaWdodHMgPSBsb2FkTmlnaHRzRGVmYXVsdCgpO1xuICAgIHZhbGlkYXRpb25FcnJvcnMgPSB7fTtcbiAgICBhd2FpdCB0aWNrKCk7XG4gICAgbmFtZUlucHV0RWw/LmZvY3VzKCk7XG4gIH1cblxuICBhc3luYyBmdW5jdGlvbiBoYW5kbGVTaG93RmFtaWx5Rm9ybSgpIHtcbiAgICBhZGRNb2RlID0gJ2ZhbWlseSc7XG4gICAgZm9ybU5hbWUgPSAnJztcbiAgICBmb3JtTmlnaHRzID0gbG9hZE5pZ2h0c0RlZmF1bHQoKTtcbiAgICBmb3JtTWVtYmVycyA9IDE7XG4gICAgdmFsaWRhdGlvbkVycm9ycyA9IHt9O1xuICAgIGF3YWl0IHRpY2soKTtcbiAgICBuYW1lSW5wdXRFbD8uZm9jdXMoKTtcbiAgfVxuXG4gIGZ1bmN0aW9uIGhhbmRsZUNhbmNlbEFkZEZvcm0oKSB7XG4gICAgYWRkTW9kZSA9IG51bGw7XG4gICAgZm9ybU5hbWUgPSAnJztcbiAgICBmb3JtTmlnaHRzID0gMTtcbiAgICBmb3JtTWVtYmVycyA9IDE7XG4gICAgdmFsaWRhdGlvbkVycm9ycyA9IHt9O1xuICB9XG5cbiAgZnVuY3Rpb24gdmFsaWRhdGVOYW1lT25JbnB1dCgpIHtcbiAgICBpZiAoIWZvcm1OYW1lLnRyaW0oKSkge1xuICAgICAgdmFsaWRhdGlvbkVycm9ycyA9IHsgLi4udmFsaWRhdGlvbkVycm9ycywgbmFtZTogdW5kZWZpbmVkIH07XG4gICAgICByZXR1cm47XG4gICAgfVxuICAgIGxldCBuYW1lRXJyb3I6IHN0cmluZyB8IHVuZGVmaW5lZDtcbiAgICBpZiAoZm9ybU5hbWUudHJpbSgpLmxlbmd0aCA+IDUwKSB7XG4gICAgICBuYW1lRXJyb3IgPSAnTmFtZSBjYW5ub3QgZXhjZWVkIDUwIGNoYXJhY3RlcnMnO1xuICAgIH0gZWxzZSBpZiAoc3BsaXQ/LnBhcnRpY2lwYW50cy5zb21lKHAgPT4gcC5uYW1lLnRvTG93ZXJDYXNlKCkgPT09IGZvcm1OYW1lLnRyaW0oKS50b0xvd2VyQ2FzZSgpKSkge1xuICAgICAgbmFtZUVycm9yID0gJ0EgcGFydGljaXBhbnQgd2l0aCB0aGlzIG5hbWUgYWxyZWFkeSBleGlzdHMnO1xuICAgIH1cbiAgICB2YWxpZGF0aW9uRXJyb3JzID0geyAuLi52YWxpZGF0aW9uRXJyb3JzLCBuYW1lOiBuYW1lRXJyb3IgfTtcbiAgfVxuXG4gIGZ1bmN0aW9uIHZhbGlkYXRlTmlnaHRzT25JbnB1dCgpIHtcbiAgICBsZXQgbmlnaHRzRXJyb3I6IHN0cmluZyB8IHVuZGVmaW5lZDtcbiAgICBpZiAoZm9ybU5pZ2h0cyA8IDEpIHtcbiAgICAgIG5pZ2h0c0Vycm9yID0gJ05pZ2h0cyBtdXN0IGJlIGF0IGxlYXN0IDEnO1xuICAgIH0gZWxzZSBpZiAoZm9ybU5pZ2h0cyA+IDM2NSkge1xuICAgICAgbmlnaHRzRXJyb3IgPSAnTmlnaHRzIGNhbm5vdCBleGNlZWQgMzY1JztcbiAgICB9XG4gICAgdmFsaWRhdGlvbkVycm9ycyA9IHsgLi4udmFsaWRhdGlvbkVycm9ycywgbmlnaHRzOiBuaWdodHNFcnJvciB9O1xuICB9XG5cbiAgZnVuY3Rpb24gdmFsaWRhdGVNZW1iZXJzT25JbnB1dCgpIHtcbiAgICBsZXQgZXJyb3I6IHN0cmluZyB8IHVuZGVmaW5lZDtcbiAgICBpZiAoZm9ybU1lbWJlcnMgPCAwLjUpIHtcbiAgICAgIGVycm9yID0gJ011c3QgYmUgYXQgbGVhc3QgMC41JztcbiAgICB9IGVsc2UgaWYgKGZvcm1NZW1iZXJzID4gNTApIHtcbiAgICAgIGVycm9yID0gJ0Nhbm5vdCBleGNlZWQgNTAnO1xuICAgIH1cbiAgICB2YWxpZGF0aW9uRXJyb3JzID0geyAuLi52YWxpZGF0aW9uRXJyb3JzLCBtZW1iZXJzOiBlcnJvciB9O1xuICB9XG5cbiAgZnVuY3Rpb24gdmFsaWRhdGVBZGRGb3JtKCk6IGJvb2xlYW4ge1xuICAgIGNvbnN0IGVycm9yczoge25hbWU/OiBzdHJpbmc7IG5pZ2h0cz86IHN0cmluZzsgbWVtYmVycz86IHN0cmluZ30gPSB7fTtcblxuICAgIGlmICghZm9ybU5hbWUudHJpbSgpKSB7XG4gICAgICBlcnJvcnMubmFtZSA9ICdOYW1lIGlzIHJlcXVpcmVkJztcbiAgICB9IGVsc2UgaWYgKGZvcm1OYW1lLnRyaW0oKS5sZW5ndGggPiA1MCkge1xuICAgICAgZXJyb3JzLm5hbWUgPSAnTmFtZSBjYW5ub3QgZXhjZWVkIDUwIGNoYXJhY3RlcnMnO1xuICAgIH0gZWxzZSBpZiAoc3BsaXQ/LnBhcnRpY2lwYW50cy5zb21lKHAgPT4gcC5uYW1lLnRvTG93ZXJDYXNlKCkgPT09IGZvcm1OYW1lLnRyaW0oKS50b0xvd2VyQ2FzZSgpKSkge1xuICAgICAgZXJyb3JzLm5hbWUgPSAnQSBwYXJ0aWNpcGFudCB3aXRoIHRoaXMgbmFtZSBhbHJlYWR5IGV4aXN0cyc7XG4gICAgfVxuXG4gICAgaWYgKGZvcm1OaWdodHMgPCAxKSB7XG4gICAgICBlcnJvcnMubmlnaHRzID0gJ05pZ2h0cyBtdXN0IGJlIGF0IGxlYXN0IDEnO1xuICAgIH0gZWxzZSBpZiAoZm9ybU5pZ2h0cyA+IDM2NSkge1xuICAgICAgZXJyb3JzLm5pZ2h0cyA9ICdOaWdodHMgY2Fubm90IGV4Y2VlZCAzNjUnO1xuICAgIH1cblxuICAgIGlmIChhZGRNb2RlID09PSAnZmFtaWx5Jykge1xuICAgICAgaWYgKGZvcm1NZW1iZXJzIDwgMC41KSB7XG4gICAgICAgIGVycm9ycy5tZW1iZXJzID0gJ011c3QgYmUgYXQgbGVhc3QgMC41JztcbiAgICAgIH0gZWxzZSBpZiAoZm9ybU1lbWJlcnMgPiA1MCkge1xuICAgICAgICBlcnJvcnMubWVtYmVycyA9ICdDYW5ub3QgZXhjZWVkIDUwJztcbiAgICAgIH1cbiAgICB9XG5cbiAgICB2YWxpZGF0aW9uRXJyb3JzID0gZXJyb3JzO1xuICAgIHJldHVybiBPYmplY3Qua2V5cyhlcnJvcnMpLmxlbmd0aCA9PT0gMDtcbiAgfVxuXG4gIGFzeW5jIGZ1bmN0aW9uIGhhbmRsZUFkZFBhcnRpY2lwYW50KCkge1xuICAgIGlmICghdmFsaWRhdGVBZGRGb3JtKCkpIHJldHVybjtcblxuICAgIGlzU3VibWl0dGluZyA9IHRydWU7XG5cbiAgICB0cnkge1xuICAgICAgY29uc3QgYWRkZWROYW1lID0gZm9ybU5hbWUudHJpbSgpO1xuICAgICAgY29uc3QgYWRkZWROaWdodHMgPSBmb3JtTmlnaHRzO1xuICAgICAgY29uc3QgYWRkZWRTaGFyZSA9IGFkZE1vZGUgPT09ICdmYW1pbHknID8gZm9ybU1lbWJlcnMgOiAxO1xuICAgICAgYXdhaXQgYWRkUGFydGljaXBhbnQoc3BsaXRJZCwge1xuICAgICAgICBuYW1lOiBhZGRlZE5hbWUsXG4gICAgICAgIG5pZ2h0czogYWRkZWROaWdodHMsXG4gICAgICAgIHNoYXJlOiBhZGRlZFNoYXJlLFxuICAgICAgfSk7XG5cbiAgICAgIHNhdmVOaWdodHNEZWZhdWx0KGFkZGVkTmlnaHRzKTtcbiAgICAgIGFkZE1vZGUgPSBudWxsO1xuICAgICAgZm9ybU5hbWUgPSAnJztcbiAgICAgIGZvcm1OaWdodHMgPSAxO1xuICAgICAgZm9ybU1lbWJlcnMgPSAxO1xuICAgICAgdmFsaWRhdGlvbkVycm9ycyA9IHt9O1xuICAgICAgYXdhaXQgbG9hZFNwbGl0KHNwbGl0SWQpO1xuXG4gICAgICBhZGRUb2FzdCh7XG4gICAgICAgIHR5cGU6ICdzdWNjZXNzJyxcbiAgICAgICAgbWVzc2FnZTogYCR7YWRkZWROYW1lfSBzdWNjZXNzZnVsbHkgYWRkZWRgLFxuICAgICAgICBkZXNjcmlwdGlvbjogYCR7YWRkZWROaWdodHN9IG5pZ2h0cyDCtyBzaGFyZSAke2FkZGVkU2hhcmV9YCxcbiAgICAgICAgZHVyYXRpb246IDQwMDAsXG4gICAgICB9KTtcbiAgICB9IGNhdGNoIChlcnI6IGFueSkge1xuICAgICAgYWRkVG9hc3Qoe1xuICAgICAgICB0eXBlOiAnZXJyb3InLFxuICAgICAgICBtZXNzYWdlOiBlcnIuZGV0YWlsIHx8ICdGYWlsZWQgdG8gYWRkIHBhcnRpY2lwYW50LiBQbGVhc2UgdHJ5IGFnYWluLicsXG4gICAgICB9KTtcbiAgICB9IGZpbmFsbHkge1xuICAgICAgaXNTdWJtaXR0aW5nID0gZmFsc2U7XG4gICAgfVxuICB9XG5cbiAgLy8gRWRpdCBQYXJ0aWNpcGFudCBoYW5kbGVyc1xuICBmdW5jdGlvbiBoYW5kbGVTdGFydEVkaXQocGFydGljaXBhbnQ6IFBhcnRpY2lwYW50KSB7XG4gICAgZWRpdGluZ1BhcnRpY2lwYW50ID0gcGFydGljaXBhbnQ7XG4gICAgc2hvd0VkaXRQYXJ0aWNpcGFudE1vZGFsID0gdHJ1ZTtcbiAgfVxuXG4gIGZ1bmN0aW9uIGhhbmRsZUVkaXRNb2RhbENsb3NlKCkge1xuICAgIHNob3dFZGl0UGFydGljaXBhbnRNb2RhbCA9IGZhbHNlO1xuICAgIGVkaXRpbmdQYXJ0aWNpcGFudCA9IG51bGw7XG4gIH1cblxuICBhc3luYyBmdW5jdGlvbiBoYW5kbGVFZGl0U3VjY2VzcygpIHtcbiAgICBjb25zdCB1cGRhdGVkUGFydGljaXBhbnRJZCA9IGVkaXRpbmdQYXJ0aWNpcGFudD8uaWQ7XG4gICAgc2hvd0VkaXRQYXJ0aWNpcGFudE1vZGFsID0gZmFsc2U7XG4gICAgZWRpdGluZ1BhcnRpY2lwYW50ID0gbnVsbDtcbiAgICBhd2FpdCBsb2FkU3BsaXQoc3BsaXRJZCk7XG5cbiAgICBpZiAodXBkYXRlZFBhcnRpY2lwYW50SWQpIHtcbiAgICAgIGhpZ2hsaWdodGVkUGFydGljaXBhbnRJZCA9IHVwZGF0ZWRQYXJ0aWNpcGFudElkO1xuICAgICAgc2V0VGltZW91dCgoKSA9PiB7XG4gICAgICAgIGhpZ2hsaWdodGVkUGFydGljaXBhbnRJZCA9IG51bGw7XG4gICAgICB9LCAyMDAwKTtcbiAgICB9XG4gIH1cblxuICAvLyBEZWxldGUgUGFydGljaXBhbnQgaGFuZGxlcnNcbiAgZnVuY3Rpb24gaGFuZGxlRGVsZXRlQ2xpY2soZXZlbnQ6IE1vdXNlRXZlbnQsIHBhcnRpY2lwYW50OiBQYXJ0aWNpcGFudCkge1xuICAgIGV2ZW50LnN0b3BQcm9wYWdhdGlvbigpO1xuICAgIGRlbGV0aW5nUGFydGljaXBhbnRJZCA9IHBhcnRpY2lwYW50LmlkO1xuICAgIGRlbGV0aW5nUGFydGljaXBhbnROYW1lID0gcGFydGljaXBhbnQubmFtZTtcbiAgfVxuXG4gIGZ1bmN0aW9uIGhhbmRsZUNhbmNlbERlbGV0ZSgpIHtcbiAgICBkZWxldGluZ1BhcnRpY2lwYW50SWQgPSBudWxsO1xuICAgIGRlbGV0aW5nUGFydGljaXBhbnROYW1lID0gJyc7XG4gIH1cblxuICBhc3luYyBmdW5jdGlvbiBoYW5kbGVDb25maXJtRGVsZXRlKCkge1xuICAgIGlmICghZGVsZXRpbmdQYXJ0aWNpcGFudElkKSByZXR1cm47XG5cbiAgICBpc0RlbGV0ZVN1Ym1pdHRpbmcgPSB0cnVlO1xuXG4gICAgdHJ5IHtcbiAgICAgIGF3YWl0IGRlbGV0ZVBhcnRpY2lwYW50KHNwbGl0SWQsIGRlbGV0aW5nUGFydGljaXBhbnRJZCk7XG4gICAgICBhd2FpdCBsb2FkU3BsaXQoc3BsaXRJZCk7XG5cbiAgICAgIGFkZFRvYXN0KHtcbiAgICAgICAgdHlwZTogJ3N1Y2Nlc3MnLFxuICAgICAgICBtZXNzYWdlOiAnUGFydGljaXBhbnQgcmVtb3ZlZCBzdWNjZXNzZnVsbHknLFxuICAgICAgICBkZXNjcmlwdGlvbjogZGVsZXRpbmdQYXJ0aWNpcGFudE5hbWUsXG4gICAgICB9KTtcblxuICAgICAgZGVsZXRpbmdQYXJ0aWNpcGFudElkID0gbnVsbDtcbiAgICAgIGRlbGV0aW5nUGFydGljaXBhbnROYW1lID0gJyc7XG4gICAgfSBjYXRjaCAoZXJyOiBhbnkpIHtcbiAgICAgIGlmIChlcnIuc3RhdHVzID09PSA0MDkpIHtcbiAgICAgICAgYWRkVG9hc3Qoe1xuICAgICAgICAgIHR5cGU6ICdlcnJvcicsXG4gICAgICAgICAgbWVzc2FnZTogYENhbm5vdCByZW1vdmUgJHtkZWxldGluZ1BhcnRpY2lwYW50TmFtZX0gLSB0aGV5IGhhdmUgYXNzb2NpYXRlZCBleHBlbnNlcy4gUmVtb3ZlIG9yIHJlYXNzaWduIHRoZWlyIGV4cGVuc2VzIGZpcnN0LmAsXG4gICAgICAgIH0pO1xuICAgICAgfSBlbHNlIHtcbiAgICAgICAgYWRkVG9hc3Qoe1xuICAgICAgICAgIHR5cGU6ICdlcnJvcicsXG4gICAgICAgICAgbWVzc2FnZTogZXJyLmRldGFpbCB8fCAnRmFpbGVkIHRvIHJlbW92ZSBwYXJ0aWNpcGFudC4gUGxlYXNlIHRyeSBhZ2Fpbi4nLFxuICAgICAgICB9KTtcbiAgICAgIH1cblxuICAgICAgZGVsZXRpbmdQYXJ0aWNpcGFudElkID0gbnVsbDtcbiAgICAgIGRlbGV0aW5nUGFydGljaXBhbnROYW1lID0gJyc7XG4gICAgfSBmaW5hbGx5IHtcbiAgICAgIGlzRGVsZXRlU3VibWl0dGluZyA9IGZhbHNlO1xuICAgIH1cbiAgfVxuXG4gIC8vIEFkZCBFeHBlbnNlIE1vZGFsIGhhbmRsZXJzXG4gIGZ1bmN0aW9uIGhhbmRsZUFkZEV4cGVuc2VDbGljayhldmVudDogTW91c2VFdmVudCwgcGFydGljaXBhbnQ6IFBhcnRpY2lwYW50KSB7XG4gICAgZXZlbnQuc3RvcFByb3BhZ2F0aW9uKCk7XG4gICAgc2VsZWN0ZWRQYXllcklkID0gcGFydGljaXBhbnQuaWQ7XG4gICAgc2hvd0FkZEV4cGVuc2VNb2RhbCA9IHRydWU7XG4gIH1cblxuICBmdW5jdGlvbiBoYW5kbGVBZGRFeHBlbnNlTW9kYWxDbG9zZSgpIHtcbiAgICBzaG93QWRkRXhwZW5zZU1vZGFsID0gZmFsc2U7XG4gICAgc2VsZWN0ZWRQYXllcklkID0gbnVsbDtcbiAgfVxuXG4gIGFzeW5jIGZ1bmN0aW9uIGhhbmRsZUFkZEV4cGVuc2VTdWNjZXNzKCkge1xuICAgIGF3YWl0IGxvYWRTcGxpdChzcGxpdElkKTtcbiAgfVxuXG4gIGZ1bmN0aW9uIGhhbmRsZURldGFpbHNDbGljayhldmVudDogTW91c2VFdmVudCwgcGFydGljaXBhbnQ6IFBhcnRpY2lwYW50KSB7XG4gICAgZXZlbnQuc3RvcFByb3BhZ2F0aW9uKCk7XG4gICAgc2VsZWN0ZWRQYXJ0aWNpcGFudEZvckV4cGVuc2VzID0gcGFydGljaXBhbnQ7XG4gICAgc2hvd0V4cGVuc2VzTW9kYWwgPSB0cnVlO1xuICB9XG5cbiAgZnVuY3Rpb24gaGFuZGxlRXhwZW5zZXNNb2RhbENsb3NlKCkge1xuICAgIHNob3dFeHBlbnNlc01vZGFsID0gZmFsc2U7XG4gICAgc2VsZWN0ZWRQYXJ0aWNpcGFudEZvckV4cGVuc2VzID0gbnVsbDtcbiAgfVxuPC9zY3JpcHQ+XG5cbjxkaXYgY2xhc3M9XCJmbGV4IGZsZXgtY29sIGl0ZW1zLWNlbnRlciBzcGFjZS15LTQgdy1mdWxsIG1heC13LVs1MjBweF0gbXgtYXV0b1wiPlxuICA8IS0tIEhlYWRlciBhbHdheXMgdmlzaWJsZSBvbmNlIHNwbGl0SWQgaXMga25vd24gLS0+XG4gIHsjaWYgc3BsaXRJZH1cbiAgICA8U3BsaXRQYWdlSGVhZGVyXG4gICAgICBzcGxpdE5hbWU9e3NwbGl0RGlzcGxheU5hbWV9XG4gICAgICB7c3BsaXRJZH1cbiAgICAgIG5hdmlnYXRlR3VhcmQ9e3NwbGl0ICYmIHNwbGl0LnBhcnRpY2lwYW50cy5sZW5ndGggPT09IDAgPyAoKSA9PiAnbm8tcGFydGljaXBhbnRzJyA6IHVuZGVmaW5lZH1cbiAgICAvPlxuICB7L2lmfVxuXG4gIHsjaWYgc2hvd0xvYWRpbmd9XG4gICAgPGRpdiBjbGFzcz1cImZsZXggZmxleC1jb2wgaXRlbXMtY2VudGVyIGp1c3RpZnktY2VudGVyIHB5LTEyIHNwYWNlLXktNFwiPlxuICAgICAgPHN2Z1xuICAgICAgICBjbGFzcz1cImFuaW1hdGUtc3BpbiBoLTggdy04IHRleHQtcHJpbWFyeVwiXG4gICAgICAgIHhtbG5zPVwiaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmdcIlxuICAgICAgICBmaWxsPVwibm9uZVwiXG4gICAgICAgIHZpZXdCb3g9XCIwIDAgMjQgMjRcIlxuICAgICAgPlxuICAgICAgICA8Y2lyY2xlIGNsYXNzPVwib3BhY2l0eS0yNVwiIGN4PVwiMTJcIiBjeT1cIjEyXCIgcj1cIjEwXCIgc3Ryb2tlPVwiY3VycmVudENvbG9yXCIgc3Ryb2tlLXdpZHRoPVwiNFwiXG4gICAgICAgID48L2NpcmNsZT5cbiAgICAgICAgPHBhdGhcbiAgICAgICAgICBjbGFzcz1cIm9wYWNpdHktNzVcIlxuICAgICAgICAgIGZpbGw9XCJjdXJyZW50Q29sb3JcIlxuICAgICAgICAgIGQ9XCJNNCAxMmE4IDggMCAwMTgtOFYwQzUuMzczIDAgMCA1LjM3MyAwIDEyaDR6bTIgNS4yOTFBNy45NjIgNy45NjIgMCAwMTQgMTJIMGMwIDMuMDQyIDEuMTM1IDUuODI0IDMgNy45MzhsMy0yLjY0N3pcIlxuICAgICAgICA+PC9wYXRoPlxuICAgICAgPC9zdmc+XG4gICAgICA8cCBjbGFzcz1cInRleHQtbXV0ZWQtZm9yZWdyb3VuZFwiPkxvYWRpbmcgcGFydGljaXBhbnRzLi4uPC9wPlxuICAgIDwvZGl2PlxuICB7OmVsc2UgaWYgIWlzTG9hZGluZyAmJiBzcGxpdH1cblxuICAgIDwhLS0gU2V0dGxlZCBCYW5uZXIgLS0+XG4gICAgeyNpZiBpc1NldHRsZWR9XG4gICAgICA8ZGl2IGNsYXNzPVwidy1mdWxsIGZsZXggaXRlbXMtY2VudGVyIGdhcC0yIHB4LTMgcHktMiByb3VuZGVkLW1kIGJnLWFtYmVyLTUwIGJvcmRlciBib3JkZXItYW1iZXItMjAwIHRleHQtc20gdGV4dC1hbWJlci04MDBcIj5cbiAgICAgICAgPHNwYW4gY2xhc3M9XCJmbGV4LTFcIj5UaGlzIHNwbGl0IGlzIHNldHRsZWQg4oCUIHBhcnRpY2lwYW50cyBhcmUgcmVhZC1vbmx5Ljwvc3Bhbj5cbiAgICAgICAgPGJ1dHRvblxuICAgICAgICAgIG9uY2xpY2s9eygpID0+IG5hdmlnYXRlKGAvc3BsaXRzLyR7c3BsaXRJZH0vc2V0dGxlbWVudGApfVxuICAgICAgICAgIGNsYXNzPVwidW5kZXJsaW5lIGZvbnQtbWVkaXVtIHdoaXRlc3BhY2Utbm93cmFwXCJcbiAgICAgICAgPlxuICAgICAgICAgIFZpZXcgc2V0dGxlbWVudFxuICAgICAgICA8L2J1dHRvbj5cbiAgICAgIDwvZGl2PlxuICAgIHsvaWZ9XG5cbiAgICA8IS0tIFBhcnRpY2lwYW50cyBTdW1tYXJ5IENhcmQgLS0+XG4gICAgPFBhcnRpY2lwYW50U3VtbWFyeUNhcmQgcGFydGljaXBhbnRzPXtzcGxpdC5wYXJ0aWNpcGFudHN9IHNob3dUaXRsZT17ZmFsc2V9IC8+XG5cbiAgICA8IS0tIEFkZCBQYXJ0aWNpcGFudCBGb3JtIC8gQnV0dG9ucyAoaGlkZGVuIHdoZW4gc2V0dGxlZCkgLS0+XG4gICAgeyNpZiAhaXNTZXR0bGVkICYmIGFkZE1vZGUgIT09IG51bGx9XG4gICAgICA8Q2FyZC5Sb290IGNsYXNzPVwidy1mdWxsXCI+XG4gICAgICAgIDxDYXJkLkNvbnRlbnQgY2xhc3M9XCJweS00XCI+XG4gICAgICAgICAgPGZvcm0gb25zdWJtaXQ9eyhlKSA9PiB7IGUucHJldmVudERlZmF1bHQoKTsgaGFuZGxlQWRkUGFydGljaXBhbnQoKTsgfX0gY2xhc3M9XCJzcGFjZS15LTNcIj5cbiAgICAgICAgICAgIDxwIGNsYXNzPVwidGV4dC1zbSBmb250LW1lZGl1bSB0ZXh0LXRlYWwtNzAwXCI+XG4gICAgICAgICAgICAgIHthZGRNb2RlID09PSAnZmFtaWx5JyA/ICdOZXcgRmFtaWx5JyA6ICdOZXcgUGFydGljaXBhbnQnfVxuICAgICAgICAgICAgPC9wPlxuXG4gICAgICAgICAgICA8ZGl2IGNsYXNzPVwic3BhY2UteS0yXCI+XG4gICAgICAgICAgICAgIDxMYWJlbCBmb3I9XCJwYXJ0aWNpcGFudC1uYW1lXCI+TmFtZTwvTGFiZWw+XG4gICAgICAgICAgICAgIDxJbnB1dFxuICAgICAgICAgICAgICAgIGlkPVwicGFydGljaXBhbnQtbmFtZVwiXG4gICAgICAgICAgICAgICAgdHlwZT1cInRleHRcIlxuICAgICAgICAgICAgICAgIHBsYWNlaG9sZGVyPVwiRW50ZXIgbmFtZVwiXG4gICAgICAgICAgICAgICAgYmluZDp2YWx1ZT17Zm9ybU5hbWV9XG4gICAgICAgICAgICAgICAgYmluZDpyZWY9e25hbWVJbnB1dEVsfVxuICAgICAgICAgICAgICAgIG9uaW5wdXQ9e3ZhbGlkYXRlTmFtZU9uSW5wdXR9XG4gICAgICAgICAgICAgICAgY2xhc3M9XCJtaW4taC1bNDRweF1cIlxuICAgICAgICAgICAgICAgIGRpc2FibGVkPXtpc1N1Ym1pdHRpbmd9XG4gICAgICAgICAgICAgIC8+XG4gICAgICAgICAgICAgIHsjaWYgdmFsaWRhdGlvbkVycm9ycy5uYW1lfVxuICAgICAgICAgICAgICAgIDxwIGNsYXNzPVwidGV4dC1zbSB0ZXh0LWRlc3RydWN0aXZlXCI+e3ZhbGlkYXRpb25FcnJvcnMubmFtZX08L3A+XG4gICAgICAgICAgICAgIHsvaWZ9XG4gICAgICAgICAgICA8L2Rpdj5cblxuICAgICAgICAgICAgPGRpdiBjbGFzcz1cImZsZXggZ2FwLTNcIj5cbiAgICAgICAgICAgICAgPGRpdiBjbGFzcz1cInNwYWNlLXktMiBmbGV4LTFcIj5cbiAgICAgICAgICAgICAgICA8ZGl2IGNsYXNzPVwiZmxleCBpdGVtcy1jZW50ZXIgZ2FwLTFcIj5cbiAgICAgICAgICAgICAgICAgIDxMYWJlbCBmb3I9XCJwYXJ0aWNpcGFudC1uaWdodHNcIj5OaWdodHM8L0xhYmVsPlxuICAgICAgICAgICAgICAgICAgPGJ1dHRvbiB0eXBlPVwiYnV0dG9uXCIgb25jbGljaz17KCkgPT4geyBhY3RpdmVGaWVsZEluZm8gPSAnbmlnaHRzJzsgfX0gY2xhc3M9XCJwLTAuNSByb3VuZGVkLWZ1bGwgaG92ZXI6YmctbXV0ZWQgdGV4dC1tdXRlZC1mb3JlZ3JvdW5kXCIgYXJpYS1sYWJlbD1cIkluZm8gYWJvdXQgTmlnaHRzXCI+XG4gICAgICAgICAgICAgICAgICAgIDxJbmZvIGNsYXNzPVwiaC0zLjUgdy0zLjVcIiAvPlxuICAgICAgICAgICAgICAgICAgPC9idXR0b24+XG4gICAgICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICAgICAgPElucHV0XG4gICAgICAgICAgICAgICAgICBpZD1cInBhcnRpY2lwYW50LW5pZ2h0c1wiXG4gICAgICAgICAgICAgICAgICB0eXBlPVwibnVtYmVyXCJcbiAgICAgICAgICAgICAgICAgIHN0ZXA9XCIxXCJcbiAgICAgICAgICAgICAgICAgIG1pbj1cIjFcIlxuICAgICAgICAgICAgICAgICAgYmluZDp2YWx1ZT17Zm9ybU5pZ2h0c31cbiAgICAgICAgICAgICAgICAgIG9uaW5wdXQ9e3ZhbGlkYXRlTmlnaHRzT25JbnB1dH1cbiAgICAgICAgICAgICAgICAgIGNsYXNzPVwibWluLWgtWzQ0cHhdXCJcbiAgICAgICAgICAgICAgICAgIGRpc2FibGVkPXtpc1N1Ym1pdHRpbmd9XG4gICAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgICAgICB7I2lmIHZhbGlkYXRpb25FcnJvcnMubmlnaHRzfVxuICAgICAgICAgICAgICAgICAgPHAgY2xhc3M9XCJ0ZXh0LXNtIHRleHQtZGVzdHJ1Y3RpdmVcIj57dmFsaWRhdGlvbkVycm9ycy5uaWdodHN9PC9wPlxuICAgICAgICAgICAgICAgIHsvaWZ9XG4gICAgICAgICAgICAgIDwvZGl2PlxuXG4gICAgICAgICAgICAgIHsjaWYgYWRkTW9kZSA9PT0gJ2ZhbWlseSd9XG4gICAgICAgICAgICAgICAgPGRpdiBjbGFzcz1cInNwYWNlLXktMiBmbGV4LTFcIj5cbiAgICAgICAgICAgICAgICAgIDxkaXYgY2xhc3M9XCJmbGV4IGl0ZW1zLWNlbnRlciBnYXAtMVwiPlxuICAgICAgICAgICAgICAgICAgICA8TGFiZWwgZm9yPVwicGFydGljaXBhbnQtbWVtYmVyc1wiPk1lbWJlcnM8L0xhYmVsPlxuICAgICAgICAgICAgICAgICAgICA8YnV0dG9uIHR5cGU9XCJidXR0b25cIiBvbmNsaWNrPXsoKSA9PiB7IGFjdGl2ZUZpZWxkSW5mbyA9ICdtZW1iZXJzJzsgfX0gY2xhc3M9XCJwLTAuNSByb3VuZGVkLWZ1bGwgaG92ZXI6YmctbXV0ZWQgdGV4dC1tdXRlZC1mb3JlZ3JvdW5kXCIgYXJpYS1sYWJlbD1cIkluZm8gYWJvdXQgTWVtYmVyc1wiPlxuICAgICAgICAgICAgICAgICAgICAgIDxJbmZvIGNsYXNzPVwiaC0zLjUgdy0zLjVcIiAvPlxuICAgICAgICAgICAgICAgICAgICA8L2J1dHRvbj5cbiAgICAgICAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICAgICAgICAgPElucHV0XG4gICAgICAgICAgICAgICAgICAgIGlkPVwicGFydGljaXBhbnQtbWVtYmVyc1wiXG4gICAgICAgICAgICAgICAgICAgIHR5cGU9XCJudW1iZXJcIlxuICAgICAgICAgICAgICAgICAgICBzdGVwPVwiYW55XCJcbiAgICAgICAgICAgICAgICAgICAgbWluPVwiMC41XCJcbiAgICAgICAgICAgICAgICAgICAgbWF4PVwiNTBcIlxuICAgICAgICAgICAgICAgICAgICBiaW5kOnZhbHVlPXtmb3JtTWVtYmVyc31cbiAgICAgICAgICAgICAgICAgICAgb25pbnB1dD17dmFsaWRhdGVNZW1iZXJzT25JbnB1dH1cbiAgICAgICAgICAgICAgICAgICAgb25rZXlkb3duPXsoZTogS2V5Ym9hcmRFdmVudCkgPT4ge1xuICAgICAgICAgICAgICAgICAgICAgIGlmIChlLmtleSA9PT0gJ0Fycm93VXAnKSB7IGUucHJldmVudERlZmF1bHQoKTsgZm9ybU1lbWJlcnMgPSBNYXRoLm1pbig1MCwgTWF0aC5yb3VuZCgoZm9ybU1lbWJlcnMgKyAwLjUpICogMTAwKSAvIDEwMCk7IHZhbGlkYXRlTWVtYmVyc09uSW5wdXQoKTsgfVxuICAgICAgICAgICAgICAgICAgICAgIGVsc2UgaWYgKGUua2V5ID09PSAnQXJyb3dEb3duJykgeyBlLnByZXZlbnREZWZhdWx0KCk7IGZvcm1NZW1iZXJzID0gTWF0aC5tYXgoMC41LCBNYXRoLnJvdW5kKChmb3JtTWVtYmVycyAtIDAuNSkgKiAxMDApIC8gMTAwKTsgdmFsaWRhdGVNZW1iZXJzT25JbnB1dCgpOyB9XG4gICAgICAgICAgICAgICAgICAgIH19XG4gICAgICAgICAgICAgICAgICAgIGNsYXNzPVwibWluLWgtWzQ0cHhdXCJcbiAgICAgICAgICAgICAgICAgICAgZGlzYWJsZWQ9e2lzU3VibWl0dGluZ31cbiAgICAgICAgICAgICAgICAgIC8+XG4gICAgICAgICAgICAgICAgICB7I2lmIHZhbGlkYXRpb25FcnJvcnMubWVtYmVyc31cbiAgICAgICAgICAgICAgICAgICAgPHAgY2xhc3M9XCJ0ZXh0LXNtIHRleHQtZGVzdHJ1Y3RpdmVcIj57dmFsaWRhdGlvbkVycm9ycy5tZW1iZXJzfTwvcD5cbiAgICAgICAgICAgICAgICAgIHsvaWZ9XG4gICAgICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICAgIHsvaWZ9XG4gICAgICAgICAgICA8L2Rpdj5cblxuICAgICAgICAgICAgPGRpdiBjbGFzcz1cImZsZXggZ2FwLTJcIj5cbiAgICAgICAgICAgICAgPEJ1dHRvbiB0eXBlPVwic3VibWl0XCIgZGlzYWJsZWQ9e2lzU3VibWl0dGluZ30gY2xhc3M9XCJmbGV4LTEgbWluLWgtWzQ0cHhdXCI+XG4gICAgICAgICAgICAgICAge2lzU3VibWl0dGluZyA/ICdBZGRpbmcuLi4nIDogJ0FkZCd9XG4gICAgICAgICAgICAgIDwvQnV0dG9uPlxuICAgICAgICAgICAgICA8QnV0dG9uIHR5cGU9XCJidXR0b25cIiB2YXJpYW50PVwib3V0bGluZVwiIG9uY2xpY2s9e2hhbmRsZUNhbmNlbEFkZEZvcm19IGRpc2FibGVkPXtpc1N1Ym1pdHRpbmd9IGNsYXNzPVwiZmxleC0xIG1pbi1oLVs0NHB4XVwiPlxuICAgICAgICAgICAgICAgIENhbmNlbFxuICAgICAgICAgICAgICA8L0J1dHRvbj5cbiAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgIDwvZm9ybT5cbiAgICAgICAgPC9DYXJkLkNvbnRlbnQ+XG4gICAgICA8L0NhcmQuUm9vdD5cbiAgICB7OmVsc2UgaWYgIWlzU2V0dGxlZH1cbiAgICAgIDxkaXYgY2xhc3M9XCJmbGV4IGZsZXgtY29sIHNtOmZsZXgtcm93IGdhcC0yIHctZnVsbFwiPlxuICAgICAgICA8QnV0dG9uXG4gICAgICAgICAgb25jbGljaz17aGFuZGxlU2hvd1NpbmdsZUZvcm19XG4gICAgICAgICAgdmFyaWFudD1cIm91dGxpbmVcIlxuICAgICAgICAgIGNsYXNzPVwic206ZmxleC0xIG1pbi1oLVs0NHB4XVwiXG4gICAgICAgID5cbiAgICAgICAgICA8VXNlciBjbGFzcz1cImgtNCB3LTQgbXItMVwiIC8+XG4gICAgICAgICAgQWRkIFNpbmdsZSBQYXJ0aWNpcGFudFxuICAgICAgICA8L0J1dHRvbj5cbiAgICAgICAgPGRpdiBjbGFzcz1cImZsZXggZ2FwLTIgc206Y29udGVudHNcIj5cbiAgICAgICAgICA8QnV0dG9uXG4gICAgICAgICAgICBvbmNsaWNrPXtoYW5kbGVTaG93RmFtaWx5Rm9ybX1cbiAgICAgICAgICAgIHZhcmlhbnQ9XCJvdXRsaW5lXCJcbiAgICAgICAgICAgIGNsYXNzPVwiZmxleC0xIHNtOmZsZXgtMSBtaW4taC1bNDRweF1cIlxuICAgICAgICAgID5cbiAgICAgICAgICAgIDxVc2VycyBjbGFzcz1cImgtNCB3LTQgbXItMVwiIC8+XG4gICAgICAgICAgICBBZGQgRmFtaWx5IFBhcnRpY2lwYW50XG4gICAgICAgICAgPC9CdXR0b24+XG4gICAgICAgICAgPEJ1dHRvblxuICAgICAgICAgICAgb25jbGljaz17KCkgPT4geyBzaG93SGVscCA9IHRydWU7IH19XG4gICAgICAgICAgICB2YXJpYW50PVwiZ2hvc3RcIlxuICAgICAgICAgICAgY2xhc3M9XCJtaW4taC1bNDRweF0gbWluLXctWzQ0cHhdIHNocmluay0wIHB4LTJcIlxuICAgICAgICAgICAgYXJpYS1sYWJlbD1cIkhlbHBcIlxuICAgICAgICAgID5cbiAgICAgICAgICAgIDxIZWxwQ2lyY2xlIGNsYXNzPVwiaC01IHctNSB0ZXh0LW11dGVkLWZvcmVncm91bmRcIiAvPlxuICAgICAgICAgIDwvQnV0dG9uPlxuICAgICAgICA8L2Rpdj5cbiAgICAgIDwvZGl2PlxuICAgIHsvaWZ9XG5cbiAgICB7I2lmIHNvcnRlZFBhcnRpY2lwYW50cy5sZW5ndGggPT09IDAgJiYgYWRkTW9kZSA9PT0gbnVsbH1cbiAgICAgIDxkaXYgY2xhc3M9XCJ3LWZ1bGwgcm91bmRlZC1sZyBib3JkZXIgYm9yZGVyLWRhc2hlZCBib3JkZXItdGVhbC0zMDAgYmctdGVhbC01MCBweC02IHB5LTggdGV4dC1jZW50ZXIgc3BhY2UteS0yXCI+XG4gICAgICAgIDxwIGNsYXNzPVwiZm9udC1zZW1pYm9sZCB0ZXh0LXRlYWwtODAwXCI+QWRkIHlvdXIgZmlyc3QgcGFydGljaXBhbnQgdG8gZ2V0IHN0YXJ0ZWQ8L3A+XG4gICAgICAgIDxwIGNsYXNzPVwidGV4dC1zbSB0ZXh0LXRlYWwtNzAwXCI+VXNlIHRoZSBidXR0b25zIGFib3ZlIHRvIGFkZCBhIHNpbmdsZSBwZXJzb24gb3IgYSBmYW1pbHkgZ3JvdXAuIFlvdSBuZWVkIGF0IGxlYXN0IG9uZSBwYXJ0aWNpcGFudCBiZWZvcmUgYWRkaW5nIGV4cGVuc2VzLjwvcD5cbiAgICAgIDwvZGl2PlxuICAgIHsvaWZ9XG5cbiAgICA8IS0tIFBhcnRpY2lwYW50IENhcmRzIC0tPlxuICAgIHsjZWFjaCBzb3J0ZWRQYXJ0aWNpcGFudHMgYXMgcGFydGljaXBhbnQgKHBhcnRpY2lwYW50LmlkKX1cbiAgICAgIHtAY29uc3Qgc3RhdHMgPSBnZXRQYXJ0aWNpcGFudFN0YXRzKHBhcnRpY2lwYW50LmlkKX1cbiAgICAgIHtAY29uc3Qgc2hhcmVkQWNjb3VudFBhcnRuZXJzID0gZ2V0U2hhcmVkQWNjb3VudFBhcnRuZXJzKHBhcnRpY2lwYW50KX1cbiAgICAgIDxDYXJkLlJvb3QgY2xhc3M9XCJ3LWZ1bGxcIj5cbiAgICAgICAgPENhcmQuQ29udGVudCBjbGFzcz1cInB5LTQgdHJhbnNpdGlvbi1jb2xvcnMgZHVyYXRpb24tNTAwIHtoaWdobGlnaHRlZFBhcnRpY2lwYW50SWQgPT09IHBhcnRpY2lwYW50LmlkID8gJ2JnLXRlYWwtNTAnIDogJyd9XCI+XG4gICAgICAgICAgPGRpdiBjbGFzcz1cImZsZXggZmxleC1jb2wgZ2FwLTFcIj5cbiAgICAgICAgICAgIDwhLS0gUm93IDE6IG5hbWUgKyBhY3Rpb24gYnV0dG9ucyAtLT5cbiAgICAgICAgICAgIDxkaXYgY2xhc3M9XCJmbGV4IGl0ZW1zLWNlbnRlciBqdXN0aWZ5LWJldHdlZW4gZ2FwLTJcIj5cbiAgICAgICAgICAgICAgPHNwYW4gY2xhc3M9XCJmb250LXNlbWlib2xkIHRleHQtbGcgdHJ1bmNhdGUgbWluLXctMCBmbGV4LTFcIj57Zm9ybWF0TmFtZShwYXJ0aWNpcGFudC5uYW1lKX08L3NwYW4+XG4gICAgICAgICAgICAgIDxkaXYgY2xhc3M9XCJmbGV4LW5vbmUgZmxleCBpdGVtcy1jZW50ZXIgZ2FwLTFcIj5cbiAgICAgICAgICAgICAgICA8QnV0dG9uXG4gICAgICAgICAgICAgICAgICB2YXJpYW50PVwiZ2hvc3RcIlxuICAgICAgICAgICAgICAgICAgc2l6ZT1cInNtXCJcbiAgICAgICAgICAgICAgICAgIG9uY2xpY2s9eyhlKSA9PiBoYW5kbGVEZXRhaWxzQ2xpY2soZSwgcGFydGljaXBhbnQpfVxuICAgICAgICAgICAgICAgICAgY2xhc3M9XCJtaW4taC1bNDRweF0gbWluLXctWzQ0cHhdXCJcbiAgICAgICAgICAgICAgICAgIGFyaWEtbGFiZWw9e2BWaWV3IGV4cGVuc2VzIGZvciAke3BhcnRpY2lwYW50Lm5hbWV9YH1cbiAgICAgICAgICAgICAgICA+XG4gICAgICAgICAgICAgICAgICA8TGlzdCBjbGFzcz1cImgtNCB3LTRcIiAvPlxuICAgICAgICAgICAgICAgIDwvQnV0dG9uPlxuICAgICAgICAgICAgICAgIDwhLS0gQWN0aW9uIEJ1dHRvbnMgKGhpZGRlbiB3aGVuIHNldHRsZWQpIC0tPlxuICAgICAgICAgICAgICAgIHsjaWYgIWlzU2V0dGxlZH1cbiAgICAgICAgICAgICAgICAgIDxCdXR0b25cbiAgICAgICAgICAgICAgICAgICAgdmFyaWFudD1cImdob3N0XCJcbiAgICAgICAgICAgICAgICAgICAgc2l6ZT1cInNtXCJcbiAgICAgICAgICAgICAgICAgICAgb25jbGljaz17KGUpID0+IGhhbmRsZUFkZEV4cGVuc2VDbGljayhlLCBwYXJ0aWNpcGFudCl9XG4gICAgICAgICAgICAgICAgICAgIGNsYXNzPVwidGV4dC1wcmltYXJ5IGhvdmVyOnRleHQtcHJpbWFyeSBob3ZlcjpiZy1wcmltYXJ5LzEwIG1pbi1oLVs0NHB4XSBtaW4tdy1bNDRweF1cIlxuICAgICAgICAgICAgICAgICAgICBhcmlhLWxhYmVsPXtgQWRkIGV4cGVuc2UgZm9yICR7cGFydGljaXBhbnQubmFtZX1gfVxuICAgICAgICAgICAgICAgICAgPlxuICAgICAgICAgICAgICAgICAgICA8UGx1cyBjbGFzcz1cImgtNCB3LTRcIiAvPlxuICAgICAgICAgICAgICAgICAgPC9CdXR0b24+XG4gICAgICAgICAgICAgICAgICA8QnV0dG9uXG4gICAgICAgICAgICAgICAgICAgIHZhcmlhbnQ9XCJnaG9zdFwiXG4gICAgICAgICAgICAgICAgICAgIHNpemU9XCJzbVwiXG4gICAgICAgICAgICAgICAgICAgIG9uY2xpY2s9eygpID0+IGhhbmRsZVN0YXJ0RWRpdChwYXJ0aWNpcGFudCl9XG4gICAgICAgICAgICAgICAgICAgIGNsYXNzPVwibWluLWgtWzQ0cHhdIG1pbi13LVs0NHB4XVwiXG4gICAgICAgICAgICAgICAgICAgIGFyaWEtbGFiZWw9e2BFZGl0ICR7cGFydGljaXBhbnQubmFtZX1gfVxuICAgICAgICAgICAgICAgICAgPlxuICAgICAgICAgICAgICAgICAgICA8c3ZnIHhtbG5zPVwiaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmdcIiBjbGFzcz1cImgtNCB3LTRcIiB2aWV3Qm94PVwiMCAwIDIwIDIwXCIgZmlsbD1cImN1cnJlbnRDb2xvclwiPlxuICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9XCJNMTMuNTg2IDMuNTg2YTIgMiAwIDExMi44MjggMi44MjhsLS43OTMuNzkzLTIuODI4LTIuODI4Ljc5My0uNzkzek0xMS4zNzkgNS43OTNMMyAxNC4xNzJWMTdoMi44MjhsOC4zOC04LjM3OS0yLjgzLTIuODI4elwiIC8+XG4gICAgICAgICAgICAgICAgICAgIDwvc3ZnPlxuICAgICAgICAgICAgICAgICAgPC9CdXR0b24+XG4gICAgICAgICAgICAgICAgICA8QnV0dG9uXG4gICAgICAgICAgICAgICAgICAgIHZhcmlhbnQ9XCJnaG9zdFwiXG4gICAgICAgICAgICAgICAgICAgIHNpemU9XCJzbVwiXG4gICAgICAgICAgICAgICAgICAgIG9uY2xpY2s9eyhlKSA9PiBoYW5kbGVEZWxldGVDbGljayhlLCBwYXJ0aWNpcGFudCl9XG4gICAgICAgICAgICAgICAgICAgIGNsYXNzPVwidGV4dC1kZXN0cnVjdGl2ZSBob3Zlcjp0ZXh0LWRlc3RydWN0aXZlIGhvdmVyOmJnLWRlc3RydWN0aXZlLzEwIG1pbi1oLVs0NHB4XSBtaW4tdy1bNDRweF1cIlxuICAgICAgICAgICAgICAgICAgICBhcmlhLWxhYmVsPXtgRGVsZXRlICR7cGFydGljaXBhbnQubmFtZX1gfVxuICAgICAgICAgICAgICAgICAgPlxuICAgICAgICAgICAgICAgICAgICA8c3ZnIHhtbG5zPVwiaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmdcIiBjbGFzcz1cImgtNCB3LTRcIiB2aWV3Qm94PVwiMCAwIDIwIDIwXCIgZmlsbD1cImN1cnJlbnRDb2xvclwiPlxuICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGZpbGwtcnVsZT1cImV2ZW5vZGRcIiBkPVwiTTkgMmExIDEgMCAwMC0uODk0LjU1M0w3LjM4MiA0SDRhMSAxIDAgMDAwIDJ2MTBhMiAyIDAgMDAyIDJoOGEyIDIgMCAwMDItMlY2YTEgMSAwIDEwMC0yaC0zLjM4MmwtLjcyNC0xLjQ0N0ExIDEgMCAwMDExIDJIOXpNNyA4YTEgMSAwIDAxMiAwdjZhMSAxIDAgMTEtMiAwVjh6bTUtMWExIDEgMCAwMC0xIDF2NmExIDEgMCAxMDIgMFY4YTEgMSAwIDAwLTEtMXpcIiBjbGlwLXJ1bGU9XCJldmVub2RkXCIgLz5cbiAgICAgICAgICAgICAgICAgICAgPC9zdmc+XG4gICAgICAgICAgICAgICAgICA8L0J1dHRvbj5cbiAgICAgICAgICAgICAgICB7L2lmfVxuICAgICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICAgPCEtLSBSb3cgMjogYmFkZ2VzIC0tPlxuICAgICAgICAgICAgPGRpdiBjbGFzcz1cImZsZXggZmxleC13cmFwIGl0ZW1zLWNlbnRlciBnYXAtMVwiPlxuICAgICAgICAgICAgICA8c3BhbiBjbGFzcz1cInRleHQteHMgcHgtMiBweS0wLjUgcm91bmRlZC1mdWxsIGJnLXRlYWwtMTAwIHRleHQtdGVhbC03MDBcIj5cbiAgICAgICAgICAgICAgICB7cGFydGljaXBhbnQubmlnaHRzfSB7cGFydGljaXBhbnQubmlnaHRzIDw9IDEgPyAnbmlnaHQnIDogJ25pZ2h0cyd9XG4gICAgICAgICAgICAgIDwvc3Bhbj5cbiAgICAgICAgICAgICAgeyNpZiBwYXJ0aWNpcGFudC5zaGFyZSA+IDF9XG4gICAgICAgICAgICAgICAgPHNwYW4gY2xhc3M9XCJ0ZXh0LXhzIHB4LTIgcHktMC41IHJvdW5kZWQtZnVsbCBiZy1ibHVlLTEwMCB0ZXh0LWJsdWUtNzAwXCI+XG4gICAgICAgICAgICAgICAgICB7cGFydGljaXBhbnQuc2hhcmV9IHtwYXJ0aWNpcGFudC5zaGFyZSA8PSAxID8gJ3NoYXJlJyA6ICdzaGFyZXMnfVxuICAgICAgICAgICAgICAgIDwvc3Bhbj5cbiAgICAgICAgICAgICAgey9pZn1cbiAgICAgICAgICAgICAgPHNwYW4gY2xhc3M9XCJ0ZXh0LXhzIHB4LTIgcHktMC41IHJvdW5kZWQtZnVsbCBiZy1zbGF0ZS0xMDAgdGV4dC1zbGF0ZS02MDBcIj5cbiAgICAgICAgICAgICAgICB7c3RhdHMuZXhwZW5zZUNvdW50fSB7c3RhdHMuZXhwZW5zZUNvdW50ID09PSAxID8gJ2V4cGVuc2UnIDogJ2V4cGVuc2VzJ31cbiAgICAgICAgICAgICAgPC9zcGFuPlxuICAgICAgICAgICAgICB7I2lmIHNoYXJlZEFjY291bnRQYXJ0bmVyc31cbiAgICAgICAgICAgICAgICA8c3BhbiBjbGFzcz1cImZsZXggaXRlbXMtY2VudGVyIGdhcC0xIHRleHQteHMgcHgtMiBweS0wLjUgcm91bmRlZC1mdWxsIGJnLXZpb2xldC0xMDAgdGV4dC12aW9sZXQtNzAwXCI+XG4gICAgICAgICAgICAgICAgICA8VXNlcnMgY2xhc3M9XCJoLTMgdy0zIHNocmluay0wXCIgLz5cbiAgICAgICAgICAgICAgICAgIHtzaGFyZWRBY2NvdW50UGFydG5lcnMuam9pbignICYgJyl9XG4gICAgICAgICAgICAgICAgPC9zcGFuPlxuICAgICAgICAgICAgICB7L2lmfVxuICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICA8IS0tIFJvdyAzOiBzdGF0cyAoZnVsbCB3aWR0aCkgLS0+XG4gICAgICAgICAgICA8ZGl2IGNsYXNzPVwiZmxleCBpdGVtcy1jZW50ZXIganVzdGlmeS1iZXR3ZWVuIHRleHQtYmFzZVwiPlxuICAgICAgICAgICAgICA8c3BhbiBjbGFzcz1cImZsZXggaXRlbXMtY2VudGVyIGdhcC0xIHRleHQtbXV0ZWQtZm9yZWdyb3VuZFwiIHRpdGxlPVwiU3BlbnRcIj5cbiAgICAgICAgICAgICAgICA8V2FsbGV0IGNsYXNzPVwiaC00IHctNCBzaHJpbmstMFwiIC8+XG4gICAgICAgICAgICAgICAgPHNwYW4gY2xhc3M9XCJmb250LW1lZGl1bSB0ZXh0LWZvcmVncm91bmRcIj57Zm9ybWF0Q3VycmVuY3koc3RhdHMuc3BlbnQpfTwvc3Bhbj5cbiAgICAgICAgICAgICAgPC9zcGFuPlxuICAgICAgICAgICAgICA8c3BhbiBjbGFzcz1cImZsZXggaXRlbXMtY2VudGVyIGdhcC0xIHRleHQtbXV0ZWQtZm9yZWdyb3VuZFwiIHRpdGxlPVwiQ29zdFwiPlxuICAgICAgICAgICAgICAgIDxSZWNlaXB0IGNsYXNzPVwiaC00IHctNCBzaHJpbmstMFwiIC8+XG4gICAgICAgICAgICAgICAgPHNwYW4gY2xhc3M9XCJmb250LW1lZGl1bSB0ZXh0LWZvcmVncm91bmRcIj57Zm9ybWF0Q3VycmVuY3koc3RhdHMuY29zdCl9PC9zcGFuPlxuICAgICAgICAgICAgICA8L3NwYW4+XG4gICAgICAgICAgICAgIDxzcGFuIGNsYXNzPVwiZmxleCBpdGVtcy1jZW50ZXIgZ2FwLTEge2JhbGFuY2VDb2xvckNsYXNzKHN0YXRzLmJhbGFuY2UpfVwiIHRpdGxlPVwiQmFsYW5jZVwiPlxuICAgICAgICAgICAgICAgIHsjaWYgc3RhdHMuYmFsYW5jZSA+IDAuMDA1fVxuICAgICAgICAgICAgICAgICAgPFRyZW5kaW5nVXAgY2xhc3M9XCJoLTQgdy00IHNocmluay0wXCIgLz5cbiAgICAgICAgICAgICAgICAgIDxzcGFuIGNsYXNzPVwiZm9udC1tZWRpdW1cIj57Zm9ybWF0Q3VycmVuY3koc3RhdHMuYmFsYW5jZSl9PC9zcGFuPlxuICAgICAgICAgICAgICAgIHs6ZWxzZSBpZiBzdGF0cy5iYWxhbmNlIDwgLTAuMDA1fVxuICAgICAgICAgICAgICAgICAgPFRyZW5kaW5nRG93biBjbGFzcz1cImgtNCB3LTQgc2hyaW5rLTBcIiAvPlxuICAgICAgICAgICAgICAgICAgPHNwYW4gY2xhc3M9XCJmb250LW1lZGl1bVwiPntmb3JtYXRDdXJyZW5jeShNYXRoLmFicyhzdGF0cy5iYWxhbmNlKSl9PC9zcGFuPlxuICAgICAgICAgICAgICAgIHs6ZWxzZX1cbiAgICAgICAgICAgICAgICAgIDxNaW51cyBjbGFzcz1cImgtNCB3LTQgc2hyaW5rLTBcIiAvPlxuICAgICAgICAgICAgICAgICAgPHNwYW4gY2xhc3M9XCJmb250LW1lZGl1bVwiPlNldHRsZWQ8L3NwYW4+XG4gICAgICAgICAgICAgICAgey9pZn1cbiAgICAgICAgICAgICAgPC9zcGFuPlxuICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgPC9kaXY+XG4gICAgICAgIDwvQ2FyZC5Db250ZW50PlxuICAgICAgPC9DYXJkLlJvb3Q+XG4gICAgey9lYWNofVxuICB7L2lmfVxuPC9kaXY+XG5cbjwhLS0gRGVsZXRlIENvbmZpcm1hdGlvbiBEaWFsb2cgLS0+XG48Q29uZmlybURpYWxvZ1xuICBvcGVuPXshIWRlbGV0aW5nUGFydGljaXBhbnRJZH1cbiAgdGl0bGU9e2BSZW1vdmUgJHtkZWxldGluZ1BhcnRpY2lwYW50TmFtZX0/YH1cbiAgZGVzY3JpcHRpb249XCJUaGlzIGNhbm5vdCBiZSB1bmRvbmUuXCJcbiAgY29uZmlybUxhYmVsPVwiUmVtb3ZlXCJcbiAgY2FuY2VsTGFiZWw9XCJDYW5jZWxcIlxuICBvbkNvbmZpcm09e2hhbmRsZUNvbmZpcm1EZWxldGV9XG4gIG9uQ2FuY2VsPXtoYW5kbGVDYW5jZWxEZWxldGV9XG4gIGlzTG9hZGluZz17aXNEZWxldGVTdWJtaXR0aW5nfVxuLz5cblxuPCEtLSBBZGQgRXhwZW5zZSBNb2RhbCAtLT5cbnsjaWYgc3BsaXR9XG4gIDxFeHBlbnNlRWRpdE1vZGFsXG4gICAgb3Blbj17c2hvd0FkZEV4cGVuc2VNb2RhbH1cbiAgICBzcGxpdElkPXtzcGxpdC5pZH1cbiAgICBwcmVzZWxlY3RlZFBheWVySWQ9e3NlbGVjdGVkUGF5ZXJJZH1cbiAgICBwYXJ0aWNpcGFudHM9e3NwbGl0LnBhcnRpY2lwYW50c31cbiAgICBvbkNsb3NlPXtoYW5kbGVBZGRFeHBlbnNlTW9kYWxDbG9zZX1cbiAgICBvblN1Y2Nlc3M9e2hhbmRsZUFkZEV4cGVuc2VTdWNjZXNzfVxuICAvPlxuey9pZn1cblxuPCEtLSBGaWVsZCBJbmZvIE1vZGFsIChhZGQgcGFydGljaXBhbnQgZm9ybSkgLS0+XG57I2lmIGFjdGl2ZUZpZWxkSW5mb31cbiAgPCEtLSBzdmVsdGUtaWdub3JlIGExMXlfY2xpY2tfZXZlbnRzX2hhdmVfa2V5X2V2ZW50cyAtLT5cbiAgPGRpdlxuICAgIGNsYXNzPVwiZml4ZWQgaW5zZXQtMCB6LVs3MF0gYmctYmxhY2svNTAgZmxleCBpdGVtcy1lbmQganVzdGlmeS1jZW50ZXIgc206aXRlbXMtY2VudGVyIHNtOnAtNFwiXG4gICAgb25jbGljaz17KCkgPT4geyBhY3RpdmVGaWVsZEluZm8gPSBudWxsOyB9fVxuICAgIHJvbGU9XCJkaWFsb2dcIlxuICAgIGFyaWEtbW9kYWw9XCJ0cnVlXCJcbiAgICBhcmlhLWxhYmVsbGVkYnk9XCJmaWVsZC1pbmZvLXRpdGxlXCJcbiAgICB0YWJpbmRleD1cIi0xXCJcbiAgPlxuICAgIDwhLS0gc3ZlbHRlLWlnbm9yZSBhMTF5X2NsaWNrX2V2ZW50c19oYXZlX2tleV9ldmVudHMgLS0+XG4gICAgPGRpdlxuICAgICAgcm9sZT1cInByZXNlbnRhdGlvblwiXG4gICAgICBjbGFzcz1cImJnLWJhY2tncm91bmQgdy1mdWxsIHNtOm1heC13LVs0MjBweF0gcm91bmRlZC10LXhsIHNtOnJvdW5kZWQteGwgc2hhZG93LWxnIGFuaW1hdGUtaW4gZmFkZS1pbiBzbGlkZS1pbi1mcm9tLWJvdHRvbS00IHNtOnpvb20taW4tOTVcIlxuICAgICAgb25jbGljaz17KGUpID0+IGUuc3RvcFByb3BhZ2F0aW9uKCl9XG4gICAgPlxuICAgICAgPGRpdiBjbGFzcz1cImZsZXggaXRlbXMtY2VudGVyIGp1c3RpZnktYmV0d2VlbiBwLTQgYm9yZGVyLWJcIj5cbiAgICAgICAgPGgyIGlkPVwiZmllbGQtaW5mby10aXRsZVwiIGNsYXNzPVwidGV4dC1iYXNlIGZvbnQtc2VtaWJvbGRcIj57ZmllbGRJbmZvW2FjdGl2ZUZpZWxkSW5mb10udGl0bGV9PC9oMj5cbiAgICAgICAgPEJ1dHRvbiB2YXJpYW50PVwiZ2hvc3RcIiBzaXplPVwic21cIiBvbmNsaWNrPXsoKSA9PiB7IGFjdGl2ZUZpZWxkSW5mbyA9IG51bGw7IH19IGNsYXNzPVwibWluLWgtWzQ0cHhdIG1pbi13LVs0NHB4XVwiIGFyaWEtbGFiZWw9XCJDbG9zZVwiPlxuICAgICAgICAgIDxYIGNsYXNzPVwiaC00IHctNFwiIC8+XG4gICAgICAgIDwvQnV0dG9uPlxuICAgICAgPC9kaXY+XG4gICAgICA8ZGl2IGNsYXNzPVwicC00IHNwYWNlLXktM1wiPlxuICAgICAgICB7I2VhY2ggZmllbGRJbmZvW2FjdGl2ZUZpZWxkSW5mb10uZGVzY3JpcHRpb24uc3BsaXQoJ1xcblxcbicpIGFzIHBhcmFncmFwaH1cbiAgICAgICAgICA8cCBjbGFzcz1cInRleHQtc20gdGV4dC1tdXRlZC1mb3JlZ3JvdW5kIGxlYWRpbmctcmVsYXhlZFwiPntwYXJhZ3JhcGh9PC9wPlxuICAgICAgICB7L2VhY2h9XG4gICAgICA8L2Rpdj5cbiAgICAgIDxkaXYgY2xhc3M9XCJwLTQgYm9yZGVyLXRcIj5cbiAgICAgICAgPEJ1dHRvbiBvbmNsaWNrPXsoKSA9PiB7IGFjdGl2ZUZpZWxkSW5mbyA9IG51bGw7IH19IGNsYXNzPVwidy1mdWxsIG1pbi1oLVs0NHB4XVwiPkdvdCBpdDwvQnV0dG9uPlxuICAgICAgPC9kaXY+XG4gICAgPC9kaXY+XG4gIDwvZGl2Plxuey9pZn1cblxuPCEtLSBFZGl0IFBhcnRpY2lwYW50IE1vZGFsIC0tPlxueyNpZiBzcGxpdH1cbiAgPEVkaXRQYXJ0aWNpcGFudE1vZGFsXG4gICAgb3Blbj17c2hvd0VkaXRQYXJ0aWNpcGFudE1vZGFsfVxuICAgIHNwbGl0SWQ9e3NwbGl0LmlkfVxuICAgIHBhcnRpY2lwYW50PXtlZGl0aW5nUGFydGljaXBhbnR9XG4gICAgcGFydGljaXBhbnRzPXtzcGxpdC5wYXJ0aWNpcGFudHN9XG4gICAge3NwbGl0fVxuICAgIG9uQ2xvc2U9e2hhbmRsZUVkaXRNb2RhbENsb3NlfVxuICAgIG9uU3VjY2Vzcz17aGFuZGxlRWRpdFN1Y2Nlc3N9XG4gIC8+XG57L2lmfVxuXG48IS0tIFBhcnRpY2lwYW50IEV4cGVuc2VzIE1vZGFsIC0tPlxueyNpZiBzcGxpdCAmJiBzZWxlY3RlZFBhcnRpY2lwYW50Rm9yRXhwZW5zZXN9XG4gIDxQYXJ0aWNpcGFudEV4cGVuc2VzTW9kYWxcbiAgICBvcGVuPXtzaG93RXhwZW5zZXNNb2RhbH1cbiAgICBwYXJ0aWNpcGFudD17c2VsZWN0ZWRQYXJ0aWNpcGFudEZvckV4cGVuc2VzfVxuICAgIGV4cGVuc2VzPXtzcGxpdC5leHBlbnNlc31cbiAgICBwYXJ0aWNpcGFudHM9e3NwbGl0LnBhcnRpY2lwYW50c31cbiAgICBvbkNsb3NlPXtoYW5kbGVFeHBlbnNlc01vZGFsQ2xvc2V9XG4gIC8+XG57L2lmfVxuXG48IS0tIEhlbHAgTW9kYWwgLS0+XG57I2lmIHNob3dIZWxwfVxuICA8IS0tIHN2ZWx0ZS1pZ25vcmUgYTExeV9jbGlja19ldmVudHNfaGF2ZV9rZXlfZXZlbnRzIC0tPlxuICA8ZGl2XG4gICAgY2xhc3M9XCJmaXhlZCBpbnNldC0wIHotWzcwXSBiZy1ibGFjay81MCBmbGV4IGl0ZW1zLWVuZCBqdXN0aWZ5LWNlbnRlciBzbTppdGVtcy1jZW50ZXIgc206cC00XCJcbiAgICBvbmNsaWNrPXsoKSA9PiB7IHNob3dIZWxwID0gZmFsc2U7IH19XG4gICAgcm9sZT1cImRpYWxvZ1wiXG4gICAgYXJpYS1tb2RhbD1cInRydWVcIlxuICAgIGFyaWEtbGFiZWxsZWRieT1cImhlbHAtbW9kYWwtdGl0bGVcIlxuICAgIHRhYmluZGV4PVwiLTFcIlxuICA+XG4gICAgPCEtLSBzdmVsdGUtaWdub3JlIGExMXlfY2xpY2tfZXZlbnRzX2hhdmVfa2V5X2V2ZW50cyAtLT5cbiAgICA8ZGl2XG4gICAgICByb2xlPVwicHJlc2VudGF0aW9uXCJcbiAgICAgIGNsYXNzPVwiYmctYmFja2dyb3VuZCB3LWZ1bGwgc206bWF4LXctWzQ4MHB4XSByb3VuZGVkLXQteGwgc206cm91bmRlZC14bCBzaGFkb3ctbGcgYW5pbWF0ZS1pbiBmYWRlLWluIHNsaWRlLWluLWZyb20tYm90dG9tLTQgc206em9vbS1pbi05NVwiXG4gICAgICBvbmNsaWNrPXsoZSkgPT4gZS5zdG9wUHJvcGFnYXRpb24oKX1cbiAgICA+XG4gICAgICA8ZGl2IGNsYXNzPVwiZmxleCBpdGVtcy1jZW50ZXIganVzdGlmeS1iZXR3ZWVuIHAtNCBib3JkZXItYlwiPlxuICAgICAgICA8aDIgaWQ9XCJoZWxwLW1vZGFsLXRpdGxlXCIgY2xhc3M9XCJ0ZXh0LWJhc2UgZm9udC1zZW1pYm9sZFwiPkhvdyB0byBhZGQgcGFydGljaXBhbnRzPC9oMj5cbiAgICAgICAgPEJ1dHRvbiB2YXJpYW50PVwiZ2hvc3RcIiBzaXplPVwic21cIiBvbmNsaWNrPXsoKSA9PiB7IHNob3dIZWxwID0gZmFsc2U7IH19IGNsYXNzPVwibWluLWgtWzQ0cHhdIG1pbi13LVs0NHB4XVwiIGFyaWEtbGFiZWw9XCJDbG9zZVwiPlxuICAgICAgICAgIDxYIGNsYXNzPVwiaC00IHctNFwiIC8+XG4gICAgICAgIDwvQnV0dG9uPlxuICAgICAgPC9kaXY+XG4gICAgICA8ZGl2IGNsYXNzPVwicC00IHNwYWNlLXktNCB0ZXh0LXNtIHRleHQtbXV0ZWQtZm9yZWdyb3VuZFwiPlxuICAgICAgICA8ZGl2IGNsYXNzPVwic3BhY2UteS0xXCI+XG4gICAgICAgICAgPHAgY2xhc3M9XCJmb250LXNlbWlib2xkIHRleHQtZm9yZWdyb3VuZCBmbGV4IGl0ZW1zLWNlbnRlciBnYXAtMS41XCI+PFVzZXIgY2xhc3M9XCJoLTQgdy00IHRleHQtdGVhbC02MDBcIiAvPiBTaW5nbGUgUGFydGljaXBhbnQ8L3A+XG4gICAgICAgICAgPHA+T25lIHBlcnNvbiBhdHRlbmRpbmcgdGhlIHRyaXAgb24gdGhlaXIgb3duLiBVc2UgdGhpcyBmb3IgaW5kaXZpZHVhbHMgd2hvIHRyYXZlbCBzb2xvIG9yIHdob3NlIGNvc3RzIHNob3VsZCBub3QgYmUgc2hhcmVkIHdpdGggYW55b25lIGVsc2UuPC9wPlxuICAgICAgICAgIDxwIGNsYXNzPVwidGV4dC14cyBiZy1tdXRlZCByb3VuZGVkIHB4LTIgcHktMS41XCI+RXhhbXBsZTogQWxpY2Ugc3RheXMgZm9yIDQgbmlnaHRzIOKGkiBhZGQgQWxpY2UgYXMgYSBzaW5nbGUgcGFydGljaXBhbnQgd2l0aCA0IG5pZ2h0cy48L3A+XG4gICAgICAgIDwvZGl2PlxuICAgICAgICA8ZGl2IGNsYXNzPVwic3BhY2UteS0xXCI+XG4gICAgICAgICAgPHAgY2xhc3M9XCJmb250LXNlbWlib2xkIHRleHQtZm9yZWdyb3VuZCBmbGV4IGl0ZW1zLWNlbnRlciBnYXAtMS41XCI+PFVzZXJzIGNsYXNzPVwiaC00IHctNCB0ZXh0LWJsdWUtNjAwXCIgLz4gRmFtaWx5IFBhcnRpY2lwYW50PC9wPlxuICAgICAgICAgIDxwPkEgZ3JvdXAgKGNvdXBsZSwgZmFtaWx5KSB3aG9zZSBjb3N0cyBhcmUgcG9vbGVkIHRvZ2V0aGVyLiBTZXQgPHN0cm9uZz5NZW1iZXJzPC9zdHJvbmc+IHRvIHRoZSB0b3RhbCBoZWFkLWNvdW50IOKAlCBhZHVsdHMgY291bnQgYXMgMSwgY2hpbGRyZW4gY2FuIGNvdW50IGFzIDAuNS48L3A+XG4gICAgICAgICAgPHAgY2xhc3M9XCJ0ZXh0LXhzIGJnLW11dGVkIHJvdW5kZWQgcHgtMiBweS0xLjVcIj5FeGFtcGxlOiBUaGUgU21pdGhzICgyIGFkdWx0cyArIDIga2lkcykgc3RheSA3IG5pZ2h0cyDihpIgYWRkIHRoZW0gYXMgYSBmYW1pbHkgd2l0aCA3IG5pZ2h0cyBhbmQgMyBtZW1iZXJzICgyIMOXIDEgKyAyIMOXIDAuNSkuPC9wPlxuICAgICAgICA8L2Rpdj5cbiAgICAgICAgPGRpdiBjbGFzcz1cInNwYWNlLXktMVwiPlxuICAgICAgICAgIDxwIGNsYXNzPVwiZm9udC1zZW1pYm9sZCB0ZXh0LWZvcmVncm91bmRcIj5NaXhlZCBzY2VuYXJpbzwvcD5cbiAgICAgICAgICA8cD5JZiBvbmUgcGFyZW50IGxlYXZlcyBlYXJseSwgYWRkIHRoZW0gc2VwYXJhdGVseSBhcyBhIHNpbmdsZSBwYXJ0aWNpcGFudCB3aXRoIGZld2VyIG5pZ2h0cy4gVGhlIHJlc3Qgb2YgdGhlIGZhbWlseSBrZWVwcyB0aGUgZnVsbCBzdGF5LjwvcD5cbiAgICAgICAgICA8cCBjbGFzcz1cInRleHQteHMgYmctbXV0ZWQgcm91bmRlZCBweC0yIHB5LTEuNVwiPkV4YW1wbGU6IERhZCBsZWF2ZXMgYWZ0ZXIgMyBuaWdodHMg4oaSIGFkZCBEYWQgKHNpbmdsZSwgMyBuaWdodHMpICsgdGhlIHJlc3Qgb2YgdGhlIGZhbWlseSAoZmFtaWx5LCA3IG5pZ2h0cywgMi41IG1lbWJlcnMpLjwvcD5cbiAgICAgICAgPC9kaXY+XG4gICAgICA8L2Rpdj5cbiAgICAgIDxkaXYgY2xhc3M9XCJwLTQgYm9yZGVyLXRcIj5cbiAgICAgICAgPEJ1dHRvbiBvbmNsaWNrPXsoKSA9PiB7IHNob3dIZWxwID0gZmFsc2U7IH19IGNsYXNzPVwidy1mdWxsIG1pbi1oLVs0NHB4XVwiPkdvdCBpdDwvQnV0dG9uPlxuICAgICAgPC9kaXY+XG4gICAgPC9kaXY+XG4gIDwvZGl2Plxuey9pZn0iXSwibWFwcGluZ3MiOiI7O1NBR1csUUFBUSxFQUFFLGNBQWMsRUFBRSxpQkFBaUIsUUFBc0MsaUJBQWlCO09BRXBHLE1BQU0sTUFBTSx5Q0FBeUM7T0FDckQsU0FBUyxNQUFNLHlCQUF5QjtPQUN4QyxLQUFLLE1BQU0sdUNBQXVDO09BQ2xELEtBQUssTUFBTSx1Q0FBdUM7T0FDbEQsYUFBYSxNQUFNLHlEQUF5RDtPQUM1RSxnQkFBZ0IsTUFBTSxpREFBaUQ7T0FDdkUsb0JBQW9CLE1BQU0seURBQXlEO09BQ25GLHdCQUF3QixNQUFNLDZEQUE2RDtPQUMzRixzQkFBc0IsTUFBTSwyREFBMkQ7U0FDckYsUUFBUSxRQUFRLCtCQUErQjtTQUMvQyxLQUFLLEVBQUUsUUFBUSxRQUFRLGFBQWE7U0FDcEMsaUJBQWlCLEVBQUUsaUJBQWlCLFFBQVEsZ0NBQWdDOzs7Q0FDNUUsSUFBSTtDQUFFLElBQUk7Q0FBRSxNQUFNO0NBQUUsT0FBTztDQUFFLFVBQVU7Q0FBRSxZQUFZO0NBQUUsS0FBSztDQUFFLElBQUk7Q0FBRSxDQUFDO0NBQUUsS0FBSztDQUFFLFVBQVU7Q0FBRSxJQUFJO09BQVEsWUFBWTs7T0FrQnBILGVBQWUsTUFBTSw2REFBNkQ7U0FDaEYsa0JBQWtCLEVBQUUsa0JBQWtCLFFBQVEsNkJBQTZCO1NBQzNFLElBQUksUUFBUSxRQUFROzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O3dEQXJDL0IsQ0FBQzs7Ozs7S0FvQkssZUFBZSxXQUF1QyxJQUFJOzs7S0FHMUQsUUFBUSxXQUFVLEtBQUs7O09BRXJCLFNBQVM7RUFDYixNQUFNO0dBQ0osS0FBSyxFQUFFLFFBQVE7R0FDZixXQUFXOzs7RUFFYixPQUFPO0dBQ0wsS0FBSyxFQUFFLFNBQVM7R0FDaEIsV0FBVzs7OztPQU9ULE9BQU8sbUJBQVksS0FBSyxDQUFDLE1BQU0sQ0FBQyxPQUFPLElBQUksRUFBRTs7O0tBRy9DLEtBQUssV0FBd0IsSUFBSTs7S0FDakMsZ0JBQWdCLG1CQUFVLGtCQUFrQixDQUFDLEtBQUssQ0FBQyxNQUFNLENBQUMsT0FBTyxJQUFJLEVBQUU7T0FDckUsa0JBQWtCLHlCQUN0QixLQUFLLEdBQUUsWUFBWSxDQUFDLEtBQUssR0FBRyxJQUFJLEVBQUUsQ0FBQyxFQUFFLENBQUMsS0FBSyxDQUFDLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxDQUFDLENBQUMsSUFBSTtPQUVsRSxTQUFTLHlCQUFZLEtBQUssR0FBRSxVQUFVLElBQUksSUFBSTtLQUNoRCxTQUFTLFdBQVUsSUFBSTtLQUN2QixXQUFXLFdBQVUsS0FBSztLQUMxQixZQUFrRCxHQUFHLElBQUk7OztLQUd6RCxPQUFPLFdBQXNDLElBQUk7O0tBQ2pELFdBQVcsV0FBbUMsSUFBSTtLQUNsRCxRQUFRLFdBQVUsRUFBRTtLQUNwQixVQUFVLFdBQVUsQ0FBQztLQUNyQixXQUFXLFdBQVUsQ0FBQztLQUN0QixnQkFBZ0I7S0FDaEIsWUFBWSxXQUFVLEtBQUs7OztLQUczQix3QkFBd0IsV0FBVSxLQUFLOztLQUN2QyxrQkFBa0IsV0FBOEIsSUFBSTtLQUNwRCx3QkFBd0IsV0FBeUIsSUFBSTs7O0tBR3JELHFCQUFxQixXQUF5QixJQUFJOztLQUNsRCx1QkFBdUIsV0FBVSxFQUFFO0tBQ25DLGtCQUFrQixXQUFVLEtBQUs7OztLQUdqQyxtQkFBbUIsV0FBVSxLQUFLOztLQUNsQyxlQUFlLFdBQXlCLElBQUk7OztLQUc1QyxpQkFBaUIsV0FBVSxLQUFLOztLQUNoQyw4QkFBOEIsV0FBOEIsSUFBSTs7O0NBSXBFLGFBQU8sT0FBTyxDQUFDO1lBQ1QsT0FBTyxHQUFFLENBQUM7R0FDWixTQUFTLE9BQUMsT0FBTztFQUNuQixDQUFDO0NBQ0gsQ0FBQzs7Z0JBRWMsU0FBUyxDQUFDLEVBQVUsRUFBRSxDQUFDO1FBQ3BDLFNBQVMsRUFBRyxJQUFJO1FBQ2hCLFdBQVcsRUFBRyxLQUFLOztNQUVmLFlBQVksRUFBRSxZQUFZLENBQUMsWUFBWTs7RUFDM0MsWUFBWSxHQUFHLFVBQVU7U0FBTyxDQUFDO1VBQUMsV0FBVyxFQUFHLElBQUk7R0FBRSxDQUFDO0dBQUUsR0FBRzs7O01BRXhELENBQUM7U0FDSCxLQUFLLFFBQVMsUUFBUSxDQUFDLEVBQUU7U0FDekIsZ0JBQWdCLFFBQUcsS0FBSyxFQUFDLElBQUk7R0FDN0Isa0JBQWtCLENBQUMsRUFBRSxRQUFFLEtBQUssRUFBQyxJQUFJO0VBQ25DLENBQUMsT0FBUSxHQUFHLEVBQUUsQ0FBQztTQUNQLFFBQVEsR0FBRyxHQUFHOztPQUNoQixRQUFRLENBQUMsTUFBTSxLQUFLLEdBQUcsSUFBSSxRQUFRLENBQUMsTUFBTSxLQUFLLEdBQUcsRUFBRSxDQUFDO0lBQ3ZELFFBQVEsR0FBRyxJQUFJLEVBQUUsTUFBTSxFQUFFLE9BQU8sRUFBRSxxQ0FBcUM7SUFDdkUsUUFBUSxDQUFDLEdBQUc7R0FDZCxDQUFDLE1BQU0sQ0FBQztJQUNOLFFBQVE7S0FDTixJQUFJLEVBQUUsT0FBTztLQUNiLE9BQU8sRUFBRSxRQUFRLENBQUMsTUFBTSxJQUFJLDZCQUE2Qjs7R0FFN0QsQ0FBQztFQUNILENBQUMsU0FBUyxDQUFDO1NBQ1QsU0FBUyxFQUFHLEtBQUs7U0FDakIsV0FBVyxFQUFHLEtBQUs7O09BQ2YsWUFBWSxFQUFFLENBQUM7SUFBQyxZQUFZLENBQUMsWUFBWTtJQUFHLFlBQVksR0FBRyxJQUFJO0dBQUUsQ0FBQztFQUN4RSxDQUFDO0NBQ0gsQ0FBQzs7O1VBR1EsbUJBQW1CLENBQUMsYUFBcUIsRUFBRSxDQUFDO2FBQzlDLEtBQUssWUFBVyxLQUFLLEVBQUUsQ0FBQyxFQUFFLElBQUksRUFBRSxDQUFDLEVBQUUsT0FBTyxFQUFFLENBQUMsRUFBRSxZQUFZLEVBQUUsQ0FBQzs7UUFFN0QsS0FBSyxTQUFHLEtBQUssRUFBQyxRQUFRLENBQ3pCLE1BQU0sRUFBQyxDQUFDLEtBQUksQ0FBQyxDQUFDLE9BQU8sS0FBSyxhQUFhLEVBQ3ZDLE1BQU0sRUFBRSxHQUFHLEVBQUUsQ0FBQyxLQUFLLEdBQUcsR0FBRyxDQUFDLENBQUMsTUFBTSxFQUFFLENBQUM7O1FBRWpDLElBQUksU0FBRyxLQUFLLEVBQUMsUUFBUSxDQUN4QixNQUFNO0lBQUUsR0FBRyxFQUFFLENBQUMsS0FBSyxDQUFDO1VBQ2IsS0FBSyxHQUFHLENBQUMsQ0FBQyxNQUFNLENBQUMsSUFBSSxFQUFDLENBQUMsS0FBSSxDQUFDLENBQUMsYUFBYSxLQUFLLGFBQWE7O1dBQzNELEdBQUcsSUFBSSxLQUFLLEVBQUUsTUFBTSxJQUFJLENBQUM7R0FDbEMsQ0FBQztHQUFFLENBQUM7OztRQUVBLFlBQVksU0FBRyxLQUFLLEVBQUMsUUFBUSxDQUNoQyxNQUFNLEVBQUMsQ0FBQyxLQUFJLENBQUMsQ0FBQyxPQUFPLEtBQUssYUFBYSxFQUN2QyxNQUFNO1FBRUgsT0FBTyxHQUFHLEtBQUssR0FBRyxJQUFJOztXQUNuQixLQUFLLEVBQUUsSUFBSSxFQUFFLE9BQU8sRUFBRSxZQUFZO0NBQzdDLENBQUM7O1VBRVEsVUFBVSxDQUFDLElBQVksRUFBVSxDQUFDO09BQ3BDLElBQUksU0FBUyxJQUFJOztTQUNmLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQyxFQUFFLFdBQVcsS0FBSyxJQUFJLENBQUMsS0FBSyxDQUFDLENBQUMsRUFBRSxXQUFXO0NBQ2pFLENBQUM7O1VBRVEsY0FBYyxDQUFDLE1BQWMsRUFBVSxDQUFDO2FBQ3BDLElBQUksQ0FBQyxZQUFZLENBQUMsT0FBTyxJQUNsQyxLQUFLLEVBQUUsVUFBVSxFQUNqQixRQUFRLEVBQUUsS0FBSyxJQUNkLE1BQU0sQ0FBQyxNQUFNO0NBQ2xCLENBQUM7O1VBRVEsaUJBQWlCLENBQUMsT0FBZSxFQUFVLENBQUM7TUFDL0MsT0FBTyxHQUFHLEtBQUssU0FBUyxnQkFBZ0I7TUFDeEMsT0FBTyxJQUFJLEtBQUssU0FBUyxjQUFjOztTQUNwQyx1QkFBdUI7Q0FDaEMsQ0FBQzs7VUFFUSxZQUFZLENBQUMsT0FBZSxFQUFVLENBQUM7TUFDMUMsT0FBTyxHQUFHLEtBQUssaUJBQWlCLGNBQWMsQ0FBQyxPQUFPO01BQ3RELE9BQU8sSUFBSSxLQUFLLGlCQUFpQixjQUFjLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxPQUFPOztTQUM3RCxTQUFTO0NBQ2xCLENBQUM7OztVQUlRLHdCQUF3QixDQUFDLFdBQXdCLEVBQW1CLENBQUM7T0FDdkUsV0FBVyxDQUFDLGVBQWUsV0FBSyxLQUFLLFVBQVMsSUFBSTs7UUFDakQsUUFBUSxTQUFHLEtBQUssRUFBQyxZQUFZLENBQ2hDLE1BQU0sRUFBQyxDQUFDLEtBQUksQ0FBQyxDQUFDLEVBQUUsS0FBSyxXQUFXLENBQUMsRUFBRSxJQUFJLENBQUMsQ0FBQyxlQUFlLEtBQUssV0FBVyxDQUFDLGVBQWUsRUFDeEYsR0FBRyxFQUFDLENBQUMsS0FBSSxDQUFDLENBQUMsSUFBSSxFQUNmLElBQUk7O1NBQ0EsUUFBUSxDQUFDLE1BQU0sR0FBRyxDQUFDLEdBQUcsUUFBUSxHQUFHLElBQUk7Q0FDOUMsQ0FBQzs7O2dCQUdjLG9CQUFvQixHQUFHLENBQUM7UUFDckMsT0FBTyxFQUFHLFFBQVE7UUFDbEIsUUFBUSxFQUFHLEVBQUU7UUFDYixVQUFVLEVBQUcsaUJBQWlCO1FBQzlCLGdCQUFnQjtRQUNWLElBQUk7UUFDVixXQUFXLEdBQUUsS0FBSztDQUNwQixDQUFDOztnQkFFYyxvQkFBb0IsR0FBRyxDQUFDO1FBQ3JDLE9BQU8sRUFBRyxRQUFRO1FBQ2xCLFFBQVEsRUFBRyxFQUFFO1FBQ2IsVUFBVSxFQUFHLGlCQUFpQjtRQUM5QixXQUFXLEVBQUcsQ0FBQztRQUNmLGdCQUFnQjtRQUNWLElBQUk7UUFDVixXQUFXLEdBQUUsS0FBSztDQUNwQixDQUFDOztVQUVRLG1CQUFtQixHQUFHLENBQUM7UUFDOUIsT0FBTyxFQUFHLElBQUk7UUFDZCxRQUFRLEVBQUcsRUFBRTtRQUNiLFVBQVUsRUFBRyxDQUFDO1FBQ2QsV0FBVyxFQUFHLENBQUM7UUFDZixnQkFBZ0I7Q0FDbEIsQ0FBQzs7VUFFUSxtQkFBbUIsR0FBRyxDQUFDO2FBQ3pCLFFBQVEsRUFBQyxJQUFJLElBQUksQ0FBQztTQUNyQixnQkFBZ0IsYUFBUSxnQkFBZ0IsR0FBRSxJQUFJLEVBQUUsU0FBUzs7O0VBRTNELENBQUM7O01BQ0csU0FBNkI7O1lBQzdCLFFBQVEsRUFBQyxJQUFJLEdBQUcsTUFBTSxHQUFHLEVBQUUsRUFBRSxDQUFDO0dBQ2hDLFNBQVMsR0FBRyxrQ0FBa0M7RUFDaEQsQ0FBQyxnQkFBVSxLQUFLLEdBQUUsWUFBWSxDQUFDLElBQUksRUFBQyxDQUFDLEtBQUksQ0FBQyxDQUFDLElBQUksQ0FBQyxXQUFXLGFBQU8sUUFBUSxFQUFDLElBQUksR0FBRyxXQUFXLEtBQUssQ0FBQztHQUNqRyxTQUFTLEdBQUcsNkNBQTZDO0VBQzNELENBQUM7O1FBQ0QsZ0JBQWdCLGFBQVEsZ0JBQWdCLEdBQUUsSUFBSSxFQUFFLFNBQVM7Q0FDM0QsQ0FBQzs7VUFFUSxxQkFBcUIsR0FBRyxDQUFDO01BQzVCLFdBQStCOztZQUMvQixVQUFVLElBQUcsQ0FBQyxFQUFFLENBQUM7R0FDbkIsV0FBVyxHQUFHLDJCQUEyQjtFQUMzQyxDQUFDLGdCQUFVLFVBQVUsSUFBRyxHQUFHLEVBQUUsQ0FBQztHQUM1QixXQUFXLEdBQUcsMEJBQTBCO0VBQzFDLENBQUM7O1FBQ0QsZ0JBQWdCLGFBQVEsZ0JBQWdCLEdBQUUsTUFBTSxFQUFFLFdBQVc7Q0FDL0QsQ0FBQzs7VUFFUSxzQkFBc0IsR0FBRyxDQUFDO01BQzdCLEtBQXlCOztZQUN6QixXQUFXLElBQUcsR0FBRyxFQUFFLENBQUM7R0FDdEIsS0FBSyxHQUFHLHNCQUFzQjtFQUNoQyxDQUFDLGdCQUFVLFdBQVcsSUFBRyxFQUFFLEVBQUUsQ0FBQztHQUM1QixLQUFLLEdBQUcsa0JBQWtCO0VBQzVCLENBQUM7O1FBQ0QsZ0JBQWdCLGFBQVEsZ0JBQWdCLEdBQUUsT0FBTyxFQUFFLEtBQUs7Q0FDMUQsQ0FBQzs7VUFFUSxlQUFlLEdBQVksQ0FBQztRQUM3QixNQUEwRDs7YUFFM0QsUUFBUSxFQUFDLElBQUksSUFBSSxDQUFDO0dBQ3JCLE1BQU0sQ0FBQyxJQUFJLEdBQUcsa0JBQWtCO0VBQ2xDLENBQUMsZ0JBQVUsUUFBUSxFQUFDLElBQUksR0FBRyxNQUFNLEdBQUcsRUFBRSxFQUFFLENBQUM7R0FDdkMsTUFBTSxDQUFDLElBQUksR0FBRyxrQ0FBa0M7RUFDbEQsQ0FBQyxnQkFBVSxLQUFLLEdBQUUsWUFBWSxDQUFDLElBQUksRUFBQyxDQUFDLEtBQUksQ0FBQyxDQUFDLElBQUksQ0FBQyxXQUFXLGFBQU8sUUFBUSxFQUFDLElBQUksR0FBRyxXQUFXLEtBQUssQ0FBQztHQUNqRyxNQUFNLENBQUMsSUFBSSxHQUFHLDZDQUE2QztFQUM3RCxDQUFDOztZQUVHLFVBQVUsSUFBRyxDQUFDLEVBQUUsQ0FBQztHQUNuQixNQUFNLENBQUMsTUFBTSxHQUFHLDJCQUEyQjtFQUM3QyxDQUFDLGdCQUFVLFVBQVUsSUFBRyxHQUFHLEVBQUUsQ0FBQztHQUM1QixNQUFNLENBQUMsTUFBTSxHQUFHLDBCQUEwQjtFQUM1QyxDQUFDOztZQUVHLE9BQU8sTUFBSyxRQUFRLEVBQUUsQ0FBQzthQUNyQixXQUFXLElBQUcsR0FBRyxFQUFFLENBQUM7SUFDdEIsTUFBTSxDQUFDLE9BQU8sR0FBRyxzQkFBc0I7R0FDekMsQ0FBQyxnQkFBVSxXQUFXLElBQUcsRUFBRSxFQUFFLENBQUM7SUFDNUIsTUFBTSxDQUFDLE9BQU8sR0FBRyxrQkFBa0I7R0FDckMsQ0FBQztFQUNILENBQUM7O1FBRUQsZ0JBQWdCLEVBQUcsTUFBTTs7U0FDbEIsTUFBTSxDQUFDLElBQUksQ0FBQyxNQUFNLEVBQUUsTUFBTSxLQUFLLENBQUM7Q0FDekMsQ0FBQzs7Z0JBRWMsb0JBQW9CLEdBQUcsQ0FBQztPQUNoQyxlQUFlOztRQUVwQixZQUFZLEVBQUcsSUFBSTs7TUFFZixDQUFDO1NBQ0csU0FBUyxTQUFHLFFBQVEsRUFBQyxJQUFJO1NBQ3pCLFdBQVcsU0FBRyxVQUFVO1NBQ3hCLFVBQVUsU0FBRyxPQUFPLE1BQUssUUFBUSxTQUFHLFdBQVcsSUFBRyxDQUFDOztTQUNuRCxjQUFjLE9BQUMsT0FBTyxLQUMxQixJQUFJLEVBQUUsU0FBUyxFQUNmLE1BQU0sRUFBRSxXQUFXLEVBQ25CLEtBQUssRUFBRSxVQUFVO0dBR25CLGlCQUFpQixDQUFDLFdBQVc7U0FDN0IsT0FBTyxFQUFHLElBQUk7U0FDZCxRQUFRLEVBQUcsRUFBRTtTQUNiLFVBQVUsRUFBRyxDQUFDO1NBQ2QsV0FBVyxFQUFHLENBQUM7U0FDZixnQkFBZ0I7U0FDVixTQUFTLE9BQUMsT0FBTzs7R0FFdkIsUUFBUTtJQUNOLElBQUksRUFBRSxTQUFTO0lBQ2YsT0FBTyxLQUFLLFNBQVM7SUFDckIsV0FBVyxLQUFLLFdBQVcsbUJBQW1CLFVBQVU7SUFDeEQsUUFBUSxFQUFFLElBQUk7O0VBRWxCLENBQUMsT0FBUSxHQUFRLEVBQUUsQ0FBQztHQUNsQixRQUFRO0lBQ04sSUFBSSxFQUFFLE9BQU87SUFDYixPQUFPLEVBQUUsR0FBRyxDQUFDLE1BQU0sSUFBSSw4Q0FBOEM7O0VBRXpFLENBQUMsU0FBUyxDQUFDO1NBQ1QsWUFBWSxFQUFHLEtBQUs7RUFDdEIsQ0FBQztDQUNILENBQUM7OztVQUdRLGVBQWUsQ0FBQyxXQUF3QixFQUFFLENBQUM7UUFDbEQsa0JBQWtCLEVBQUcsV0FBVztRQUNoQyx3QkFBd0IsRUFBRyxJQUFJO0NBQ2pDLENBQUM7O1VBRVEsb0JBQW9CLEdBQUcsQ0FBQztRQUMvQix3QkFBd0IsRUFBRyxLQUFLO1FBQ2hDLGtCQUFrQixFQUFHLElBQUk7Q0FDM0IsQ0FBQzs7Z0JBRWMsaUJBQWlCLEdBQUcsQ0FBQztRQUM1QixvQkFBb0IsU0FBRyxrQkFBa0IsR0FBRSxFQUFFOztRQUNuRCx3QkFBd0IsRUFBRyxLQUFLO1FBQ2hDLGtCQUFrQixFQUFHLElBQUk7UUFDbkIsU0FBUyxPQUFDLE9BQU87O01BRW5CLG9CQUFvQixFQUFFLENBQUM7U0FDekIsd0JBQXdCLEVBQUcsb0JBQW9COztHQUMvQyxVQUFVO1VBQU8sQ0FBQztXQUNoQix3QkFBd0IsRUFBRyxJQUFJO0lBQ2pDLENBQUM7SUFBRSxJQUFJOztFQUNULENBQUM7Q0FDSCxDQUFDOzs7VUFHUSxpQkFBaUIsQ0FBQyxLQUFpQixFQUFFLFdBQXdCLEVBQUUsQ0FBQztFQUN2RSxLQUFLLENBQUMsZUFBZTtRQUNyQixxQkFBcUIsRUFBRyxXQUFXLENBQUMsRUFBRTtRQUN0Qyx1QkFBdUIsRUFBRyxXQUFXLENBQUMsSUFBSTtDQUM1QyxDQUFDOztVQUVRLGtCQUFrQixHQUFHLENBQUM7UUFDN0IscUJBQXFCLEVBQUcsSUFBSTtRQUM1Qix1QkFBdUIsRUFBRyxFQUFFO0NBQzlCLENBQUM7O2dCQUVjLG1CQUFtQixHQUFHLENBQUM7YUFDL0IscUJBQXFCOztRQUUxQixrQkFBa0IsRUFBRyxJQUFJOztNQUVyQixDQUFDO1NBQ0csaUJBQWlCLE9BQUMsT0FBTyxTQUFFLHFCQUFxQjtTQUNoRCxTQUFTLE9BQUMsT0FBTzs7R0FFdkIsUUFBUTtJQUNOLElBQUksRUFBRSxTQUFTO0lBQ2YsT0FBTyxFQUFFLGtDQUFrQztJQUMzQyxXQUFXLFFBQUUsdUJBQXVCOzs7U0FHdEMscUJBQXFCLEVBQUcsSUFBSTtTQUM1Qix1QkFBdUIsRUFBRyxFQUFFO0VBQzlCLENBQUMsT0FBUSxHQUFRLEVBQUUsQ0FBQztPQUNkLEdBQUcsQ0FBQyxNQUFNLEtBQUssR0FBRyxFQUFFLENBQUM7SUFDdkIsUUFBUTtLQUNOLElBQUksRUFBRSxPQUFPO0tBQ2IsT0FBTyx5QkFBbUIsdUJBQXVCOztHQUVyRCxDQUFDLE1BQU0sQ0FBQztJQUNOLFFBQVE7S0FDTixJQUFJLEVBQUUsT0FBTztLQUNiLE9BQU8sRUFBRSxHQUFHLENBQUMsTUFBTSxJQUFJLGlEQUFpRDs7R0FFNUUsQ0FBQzs7U0FFRCxxQkFBcUIsRUFBRyxJQUFJO1NBQzVCLHVCQUF1QixFQUFHLEVBQUU7RUFDOUIsQ0FBQyxTQUFTLENBQUM7U0FDVCxrQkFBa0IsRUFBRyxLQUFLO0VBQzVCLENBQUM7Q0FDSCxDQUFDOzs7VUFHUSxxQkFBcUIsQ0FBQyxLQUFpQixFQUFFLFdBQXdCLEVBQUUsQ0FBQztFQUMzRSxLQUFLLENBQUMsZUFBZTtRQUNyQixlQUFlLEVBQUcsV0FBVyxDQUFDLEVBQUU7UUFDaEMsbUJBQW1CLEVBQUcsSUFBSTtDQUM1QixDQUFDOztVQUVRLDBCQUEwQixHQUFHLENBQUM7UUFDckMsbUJBQW1CLEVBQUcsS0FBSztRQUMzQixlQUFlLEVBQUcsSUFBSTtDQUN4QixDQUFDOztnQkFFYyx1QkFBdUIsR0FBRyxDQUFDO1FBQ2xDLFNBQVMsT0FBQyxPQUFPO0NBQ3pCLENBQUM7O1VBRVEsa0JBQWtCLENBQUMsS0FBaUIsRUFBRSxXQUF3QixFQUFFLENBQUM7RUFDeEUsS0FBSyxDQUFDLGVBQWU7UUFDckIsOEJBQThCLEVBQUcsV0FBVztRQUM1QyxpQkFBaUIsRUFBRyxJQUFJO0NBQzFCLENBQUM7O1VBRVEsd0JBQXdCLEdBQUcsQ0FBQztRQUNuQyxpQkFBaUIsRUFBRyxLQUFLO1FBQ3pCLDhCQUE4QixFQUFHLElBQUk7Q0FDdkMsQ0FBQzs7Ozs7Ozs7O21DQVNrQixLQUFLLFdBQUksS0FBSyxFQUFDLFlBQVksQ0FBQyxNQUFNLEtBQUssQ0FBQyxTQUFTLGlCQUFpQixHQUFHLFNBQVM7Ozs7bUJBRmxGLGdCQUFnQjs7Ozs7Ozs7Ozs7Ozs7O2FBRjFCLE9BQU87Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs4QkFpQ1csUUFBUSxrQkFBWSxPQUFPOzs7Ozs7aUJBSjNDLFNBQVM7Ozs7Ozs7O29CQWF3QixLQUFLLEVBQUMsWUFBWTs7O2lCQUFhLEtBQUs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7dUJBbUJyRCxtQkFBbUI7Ozs7NEJBRWxCLFlBQVk7Ozs7NEJBSlYsUUFBUTs7OztxQkFBUixRQUFROzs7OzRCQUNWLFdBQVc7Ozs7cUJBQVgsV0FBVzs7Ozs7Ozs7Ozs7O2dFQU1nQixnQkFBZ0IsRUFBQyxJQUFJOzs7Ozt5QkFEdkQsZ0JBQWdCLEVBQUMsSUFBSTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O3NDQVNlLENBQUM7b0JBQUMsZUFBZSxFQUFHLFFBQVE7YUFBRSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7dUJBVTNELHFCQUFxQjs7Ozs0QkFFcEIsWUFBWTs7Ozs0QkFIVixVQUFVOzs7O3FCQUFWLFVBQVU7Ozs7Ozs7Ozs7OztnRUFNZSxnQkFBZ0IsRUFBQyxNQUFNOzs7Ozt5QkFEekQsZ0JBQWdCLEVBQUMsTUFBTTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O3dDQVNhLENBQUM7c0JBQUMsZUFBZSxFQUFHLFNBQVM7ZUFBRSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7O3lCQVc1RCxzQkFBc0I7OzRCQUNuQixDQUFnQixLQUFLLENBQUM7cUJBQzVCLENBQUMsQ0FBQyxHQUFHLEtBQUssU0FBUyxFQUFFLENBQUM7a0JBQUMsQ0FBQyxDQUFDLGNBQWM7d0JBQUksV0FBVyxFQUFHLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxFQUFFLElBQUksQ0FBQyxLQUFLLFFBQUUsV0FBVyxJQUFHLEdBQUcsSUFBSSxHQUFHLElBQUksR0FBRztrQkFBRyxzQkFBc0I7aUJBQUksQ0FBQyxVQUMxSSxDQUFDLENBQUMsR0FBRyxLQUFLLFdBQVcsRUFBRSxDQUFDO2tCQUFDLENBQUMsQ0FBQyxjQUFjO3dCQUFJLFdBQVcsRUFBRyxJQUFJLENBQUMsR0FBRyxDQUFDLEdBQUcsRUFBRSxJQUFJLENBQUMsS0FBSyxRQUFFLFdBQVcsSUFBRyxHQUFHLElBQUksR0FBRyxJQUFJLEdBQUc7a0JBQUcsc0JBQXNCO2lCQUFJLENBQUM7Z0JBQzdKLENBQUM7Ozs7OzhCQUVTLFlBQVk7Ozs7OEJBUFYsV0FBVzs7Ozt1QkFBWCxXQUFXOzs7Ozs7Ozs7Ozs7a0VBVWMsZ0JBQWdCLEVBQUMsT0FBTzs7Ozs7MkJBRDFELGdCQUFnQixFQUFDLE9BQU87Ozs7Ozs7Ozt5QkF2QjVCLE9BQU8sTUFBSyxRQUFROzs7Ozs7Ozs7Ozs7OzRCQStCTyxZQUFZOzs7Ozs7Ozs7O2dFQUN6QyxZQUFZLElBQUcsV0FBVyxHQUFHLEtBQUs7Ozs7Ozs7Ozs7Ozt1QkFFWSxtQkFBbUI7Ozs0QkFBWSxZQUFZOzs7Ozs7Ozs7Ozs7Ozs7Ozs7NERBN0UzRixPQUFPLE1BQUssUUFBUSxHQUFHLFlBQVksR0FBRyxpQkFBaUI7O3NDQUYzQyxDQUFDLEtBQUssQ0FBQztjQUFDLENBQUMsQ0FBQyxjQUFjO2NBQUksb0JBQW9CO2FBQUksQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7bUJBeUY3RCxvQkFBb0I7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O21CQVNsQixvQkFBb0I7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7eUJBUWQsQ0FBQztpQkFBQyxRQUFRLEVBQUcsSUFBSTtVQUFFLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztxQkFwQmhDLFNBQVM7Ozs7Ozs7Ozs7a0JBekZkLFNBQVMsV0FBSSxPQUFPLE1BQUssSUFBSTs7Ozs7Ozs7Ozs7Ozs7aUJBd0g5QixrQkFBa0IsRUFBQyxNQUFNLEtBQUssQ0FBQyxVQUFJLE9BQU8sTUFBSyxJQUFJOzs7Ozs7cUNBUWpELGtCQUFrQixJQUFJLFdBQVcsS0FBRSxXQUFXLENBQUMsRUFBRSxhQUEzQixXQUFXO1lBQzlCLEtBQUssbUJBQUcsbUJBQW1CLE9BQUMsV0FBVyxFQUFDLEVBQUU7WUFDMUMscUJBQXFCLG1CQUFHLHdCQUF3QixPQUFDLFdBQVc7Ozs7Ozs7Ozs7Ozs7eUNBRVIsd0JBQXdCLFlBQUssV0FBVyxFQUFDLEVBQUUsR0FBRyxZQUFZLEdBQUcsRUFBRTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7a0VBVzlFLFdBQVcsRUFBQyxJQUFJOzs7Ozt5QkFGdkMsQ0FBQyxLQUFLLGtCQUFrQixDQUFDLENBQUMsUUFBRSxXQUFXOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztrRUFhaEIsV0FBVyxFQUFDLElBQUk7Ozs7OzJCQUZyQyxDQUFDLEtBQUsscUJBQXFCLENBQUMsQ0FBQyxRQUFFLFdBQVc7Ozs7Ozs7Ozs7Ozs7Ozs7Ozt1REFXaEMsV0FBVyxFQUFDLElBQUk7Ozs7O2dDQUZyQixlQUFlLE9BQUMsV0FBVzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7eURBYXBCLFdBQVcsRUFBQyxJQUFJOzs7OzsyQkFGNUIsQ0FBQyxLQUFLLGlCQUFpQixDQUFDLENBQUMsUUFBRSxXQUFXOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7MEJBeEI5QyxTQUFTOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0VBMENaLFdBQVcsRUFBQyxLQUFLLGdCQUFHLFdBQVcsRUFBQyxLQUFLLElBQUksQ0FBQyxHQUFHLE9BQU8sR0FBRyxRQUFROzs7Ozt5QkFGL0QsV0FBVyxFQUFDLEtBQUssR0FBRyxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7MkZBV3JCLHFCQUFxQixFQUFDLElBQUksQ0FBQyxLQUFLOzs7Ozt5QkFIaEMscUJBQXFCOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O3lFQW9CSyxjQUFjLE9BQUMsS0FBSyxFQUFDLE9BQU87Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7MkVBRzVCLGNBQWMsQ0FBQyxJQUFJLENBQUMsR0FBRyxPQUFDLEtBQUssRUFBQyxPQUFPOzs7Ozs7Ozs7Ozs7Ozs7OzRCQUZ4RCxLQUFLLEVBQUMsT0FBTyxJQUFJLEtBQUs7Ozs7Ozs7Ozs7eUJBSDNCLEtBQUssRUFBQyxPQUFPLEdBQUcsS0FBSzs7Ozs7Ozs7Ozs7NENBNUJ6QixXQUFXLEVBQUMsTUFBTSxnQkFBRyxXQUFXLEVBQUMsTUFBTSxJQUFJLENBQUMsR0FBRyxPQUFPLEdBQUcsUUFBUTs0Q0FRakUsS0FBSyxFQUFDLFlBQVksZ0JBQUcsS0FBSyxFQUFDLFlBQVksS0FBSyxDQUFDLEdBQUcsU0FBUyxHQUFHLFVBQVU7Ozs7OztxQkExRFosVUFBVSxPQUFDLFdBQVcsRUFBQyxJQUFJO3FCQXVFM0MsY0FBYyxPQUFDLEtBQUssRUFBQyxLQUFLO3FCQUkxQixjQUFjLE9BQUMsS0FBSyxFQUFDLElBQUk7cUJBRWhDLGlCQUFpQixPQUFDLEtBQUssRUFBQyxPQUFPOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O2lCQXhPdEUsU0FBUyxXQUFJLEtBQUs7Ozs7Ozs7Ozs7YUFsQnhCLFdBQVc7Ozs7Ozs7OzttQ0FnUlIscUJBQXFCOzJDQUNaLHVCQUF1Qjs7Ozs7Ozs7Ozs7Ozs7Y0FJN0IsbUJBQW1CO2FBQ3BCLGtCQUFrQjs7O2lCQUNqQixrQkFBa0I7Ozs7Ozs7Ozs7O2tCQU1yQixtQkFBbUI7Ozs7a0JBQ2hCLEtBQUssRUFBQyxFQUFFOzs7O2tCQUNHLGVBQWU7Ozs7a0JBQ3JCLEtBQUssRUFBQyxZQUFZOzs7YUFDdkIsMEJBQTBCO2VBQ3hCLHVCQUF1Qjs7Ozs7YUFQakMsS0FBSzs7Ozs7Ozs7OzswQkFnQlMsQ0FBQztVQUFDLGVBQWUsRUFBRyxJQUFJO0dBQUUsQ0FBQzs7OztxQkFVOUIsQ0FBQyxLQUFLLENBQUMsQ0FBQyxlQUFlOzs7Ozs7Ozs7Ozs7OzttQkFJa0IsQ0FBQztXQUFDLGVBQWUsRUFBRyxJQUFJO0lBQUUsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs0QkFLckUsU0FBUyxPQUFDLGVBQWUsR0FBRSxXQUFXLENBQUMsS0FBSyxDQUFDLE1BQU0sdUJBQUssU0FBUzs7Ozs7c0RBQ1osU0FBUzs7Ozs7Ozs7OzttQkFJOUMsQ0FBQztXQUFDLGVBQWUsRUFBRyxJQUFJO0lBQUUsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7OytDQVhTLFNBQVMsT0FBQyxlQUFlLEdBQUUsS0FBSzs7Ozs7YUFqQjlGLGVBQWU7Ozs7Ozs7Ozs7a0JBcUNWLHdCQUF3Qjs7OztrQkFDckIsS0FBSyxFQUFDLEVBQUU7Ozs7a0JBQ0osa0JBQWtCOzs7O2tCQUNqQixLQUFLLEVBQUMsWUFBWTs7Ozs7OzthQUV2QixvQkFBb0I7ZUFDbEIsaUJBQWlCOzs7OzthQVIzQixLQUFLOzs7Ozs7Ozs7O2tCQWVBLGlCQUFpQjs7OztrQkFDViw4QkFBOEI7Ozs7a0JBQ2pDLEtBQUssRUFBQyxRQUFROzs7O2tCQUNWLEtBQUssRUFBQyxZQUFZOzs7YUFDdkIsd0JBQXdCOzs7OzthQU5oQyxLQUFLLFdBQUksOEJBQThCOzs7Ozs7Ozs7OzBCQWV6QixDQUFDO1VBQUMsUUFBUSxFQUFHLEtBQUs7R0FBRSxDQUFDOzs7O3FCQVV4QixDQUFDLEtBQUssQ0FBQyxDQUFDLGVBQWU7Ozs7Ozs7OzttQkFJa0IsQ0FBQztXQUFDLFFBQVEsRUFBRyxLQUFLO0lBQUUsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7bUJBc0IvQyxDQUFDO1dBQUMsUUFBUSxFQUFHLEtBQUs7SUFBRSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O2FBeEMvQyxRQUFROzs7Ozs7QUE5V2QsQ0FBQzs7In0=